
var HuEmoji = function(input, trigger, attach, options) {

  /* CONSTRUCTOR ********************************************/

  this.DEFAULTS = {
    pages:      ['People', 'Nature', 'Food', 'Activity', 'Travel', 'Objects', 'Symbols', 'Flags'],
    search:     false,
    preview:    false,
    width:      '325px',
    height:     '200px',
    positionY:  'top',
    positionX:  'right',
    offsetY:    0,
    offsetX:    0,
    spritesUrl: '',
  };

  this.options = this.extendDefaults(this.DEFAULTS, options);

  // Error handlers
  // --------------

  // input error
  if (typeof input !== 'object')
    throw new TypeError('input must be an object, type ' + typeof input + ' was given instead.');

  // trigger error
  if (typeof trigger !== 'object')
    throw new TypeError('trigger must be an object, type ' + typeof trigger + ' was given instead.');

  // attach error
  if (typeof attach !== 'object')
    throw new TypeError('attach must be an object, type ' + typeof attach + ' was given instead.');

  // options error
  if (typeof options !== 'object')
    throw new TypeError('options must be an object, type ' + typeof options + ' was given instead.');

  // page doesn't exist
  this.options.pages.map(function(page, index) {
    if (HuEmoji.emojiPages.indexOf(page) < 0)
      throw new TypeError('options.page "' + this.options.pages[index] + '" doesn\'t exist. Try these: ' + HuEmoji.emojiPages);
  });

  // search is not boolean
  if (typeof this.options.search !== 'boolean')
    throw new TypeError('options.search must be a boolean, type ' + typeof this.options.search + ' was given instead.');

  // preview is not boolean
  if (typeof this.options.preview !== 'boolean')
    throw new TypeError('options.preview must be a boolean, type ' + typeof this.options.preview + ' was given instead.');

  // positionY error
  if (HuEmoji.positionYValues.indexOf(this.options.positionY) < 0)
    throw new TypeError('options.positionY value "'+ this.options.positionY +'" not available, try these: ' + HuEmoji.positionYValues);

  // positionX error
  if (HuEmoji.positionXValues.indexOf(this.options.positionX) < 0)
    throw new TypeError('options.positionX value "'+ this.options.positionX +'" not available, try these: ' + HuEmoji.positionXValues);

  // offsetY | offsetX is not number
  if (typeof this.options.offsetY !== 'number' || typeof this.options.offsetX !== 'number')
    throw new TypeError('options.offset must be a number');

  // spritesUrl is not string
  if (typeof this.options.spritesUrl !== 'string')
    throw new TypeError('options.spritesUrl must be a string, type ' + typeof options + ' was given instead.');


  this.input        = input;
  this.trigger      = trigger;
  this.attach       = attach;
  this.container    = null;
  this.tabs         = null;
  this.search       = null;
  this.pagesScroll  = null;
  this.checkScroll  = true;
  this.preview      = null;

  this.init();
};

HuEmoji.VERSION = '1.0.1';

/* CONSTANTS ********************************************/
HuEmoji.positionYValues = ['top', 'bottom'];
HuEmoji.positionXValues = ['left', 'center', 'right'];
HuEmoji.emojiPages = ['People', 'Nature', 'Food', 'Activity', 'Travel', 'Objects', 'Symbols', 'Flags'];
HuEmoji.contamination = 15;
/********************************************************/


/**
 * Merge defaults with input options
 * @param  {Object} defaults Default options
 * @param  {Object} options User input options
 * @return {Object} Object with merged options
 */
HuEmoji.prototype.extendDefaults = function(defaults, options) {
  for (var key in options) {
    if (options.hasOwnProperty(key) && defaults.hasOwnProperty(key)) {
      defaults[key] = options[key];
    }
  }
  return defaults;
}

/**
 * Toggle emoji picker
 * @param  {Object} e Mouse click event
 */
HuEmoji.prototype.toggle = function(e) {
  if (this.container.contains(e.target))
    return;
  var state = this.container.style.display === 'block';
  if (state === true)
    this.hide();
  else
    this.show();
};

/**
 * Show emoji picker
 */
HuEmoji.prototype.show = function() {
  this.container.style.display = 'block';
  if (this.options.search)
    this.search.focus();
  // On first show, calc scroll positions
  if (this.pagesScroll == null)
    this.pagesScroll = this.getAllPagesPosition();
};

/**
 * Hide emoji picker
 */
HuEmoji.prototype.hide = function() {
  this.container.style.display = 'none';
  // Cancel search
  if (this.search)
    this.cancelSearch();
};

/**
 * Hide emoji picker on click outside
 * @param  {Object} e Mouse click event
 */
HuEmoji.prototype.globalHide = function(e) {
  if (this.container.contains(e.target) || this.trigger.contains(e.target))
    return;
  if (this.container.style.display == 'block')
    this.hide();
};

HuEmoji.prototype.setInput = function(elem) {
  this.input = elem;
}

/**
 * Set emoji picker position (initial)
 */
HuEmoji.prototype.setContainerPosition = function() {
  var isTop = this.options.positionY == 'top';
  var isBottom = this.options.positionY == 'bottom';
  var isLeft = this.options.positionX == 'left';
  var isCenter = this.options.positionX == 'center';
  var isRight = this.options.positionX == 'right';
  if (isTop)
    this.container.style.bottom = this.options.offsetY + 'px';
  else if (isBottom)
    this.container.style.top = this.options.offsetY + 'px';
  if (isLeft)
    this.container.style.right = this.options.offsetX + 'px';
  else if (isCenter) {
    this.container.style.left = 0;
    this.container.style.right = 0;
    this.container.style.margin = '0 auto';
  }
  else if (isRight)
    this.container.style.left = this.options.offsetX + 'px';
};

/**
 * Set emoji picker position (update)
 * @param  {Number} offsetY Y axis increment
 * @param  {Number} offsetX X axis increment
 */
HuEmoji.prototype.updateContainerPosition = function(offsetY, offsetX) {
  var isTop = this.options.positionY == 'top';
  var isBottom = this.options.positionY == 'bottom';
  var isLeft = this.options.positionX == 'left';
  var isRight = this.options.positionX == 'right';
  if (isTop)
    this.container.style.bottom = this.options.offsetY  + offsetY + 'px';
  else if (isBottom)
    this.container.style.top = this.options.offsetY + offsetY + 'px';
  if (isLeft)
    this.container.style.right = this.options.offsetX + offsetX + 'px';
  else if (isRight)
    this.container.style.left = this.options.offsetX + offsetX + 'px';
};

/**
 * Select emojis page directly or from topbar tab
 * @param  {String|Object} e Page name | Mouse click event
 */
HuEmoji.prototype.selectPage = function(e) {
  // Cancel search
  if (this.search)
    this.cancelSearch();

  var page = (e.target) ? (e.target.parentNode.getAttribute('data-tab') || e.target.getAttribute('data-tab')) : e;
  // Set active tab class
  this.pageClassHandler(page);
  // Scrolls to page
  this.checkScroll = false; // checkScroll vuelve a ser true tras un cierto delay
  this.container.querySelector('section').scrollTop = this.getPagePosition(page);
};

/**
 * Set topbar tabs classes when page changes
 * @param  {String} page Page name
 */
HuEmoji.prototype.pageClassHandler = function(page) {
  var activeTabs = this.tabs.querySelectorAll('li.hu-active');
  for (var tab = 0; tab < activeTabs.length; tab++) {
    activeTabs[tab].className = activeTabs[tab].className.replace(' hu-active', '');
  }
  var selectedTab = this.tabs.querySelector('[data-tab="' + page +'"]');
  selectedTab.className += ' hu-active';
}

/**
 * On scroll handler
 */
HuEmoji.prototype.scrollListener = function(e) {
  // this.checkScroll = true;
  if (this.checkScroll) {
    this.checkScroll = false;
    var currentScroll = e.target.scrollTop;
    var page = this.getPageFromScroll(currentScroll);
    this.pageClassHandler(page);
  }
  setTimeout(function() {
    this.checkScroll = true;
  }, 200);
}

/**
 * Get emoji pages scroll position
 * @return {Array} Array with all pages scroll position
 */
HuEmoji.prototype.getAllPagesPosition = function() {
  var pages = this.options.pages;
  var pagesPosition = [];
  for (var page in pages) {
    var position = this.container.querySelector('#page_' + pages[page]).offsetTop;
    if (this.options.search === true)
      position -= 91;
    else
      position -= 49;
    pagesPosition.push(position);
  }
  return pagesPosition;
};

/**
 * Get a specific page scroll position
 * @param  {String} page Page name
 * @return {Number} Page scroll position
 */
HuEmoji.prototype.getPagePosition = function(page) {
  var position = this.container.querySelector('#page_' + page).offsetTop;
  if (this.options.search === true)
    position -= 91;
  else
    position -= 49;
  return position + 1;
}

/**
 * Get which page matches current scroll position
 * @param  {Number} scroll Scroll position
 * @return {String} Page name
 */
HuEmoji.prototype.getPageFromScroll = function(scroll) {
  var pages = this.options.pages;
  var page = null;
  for (var i = pages.length - 1; i > -1; i--) {
    if (scroll > this.pagesScroll[i]) {
      page = pages[i];
      break;
    }
  }
  return (page !== null) ? page : pages[0];
}

/**
 * On search input change handler
 */
HuEmoji.prototype.searchListener = function(e) {
  var search = e.target.value.toLowerCase();
  var matches = [];
  if (search != '') {
    var matches = this.getObjectsFromJSON(HuEmoji.EMOJIS, search);
    this.showSearchPage();
    this.fillSearchPage(matches);
  } else {
    this.hideSearchPage();
  }
}

/**
 * Show search page and hide standard pages
 */
HuEmoji.prototype.showSearchPage = function() {
  for (var i = 0; i < this.options.pages.length; i++) {
    var page = this.container.querySelector('#page_' + this.options.pages[i]);
    if (page.className.indexOf('hu-hidden') == -1)
      page.className += ' hu-hidden';
  }
  var searchPage = this.container.querySelector('#page_Search');
  if (searchPage.className.indexOf('hu-hidden') == -1)
    return;
  else
    searchPage.className = searchPage.className.replace(' hu-hidden', '');
};

/**
 * Hide search page and show standard pages
 */
HuEmoji.prototype.hideSearchPage = function() {
  for (var i = 0; i < this.options.pages.length; i++) {
    var page = this.container.querySelector('#page_' + this.options.pages[i]);
    if (page.className.indexOf('hu-hidden') > -1) {
      page.className = page.className.replace(' hu-hidden', '');
    }
  }
  var searchPage = this.container.querySelector('#page_Search');
  if (searchPage.className.indexOf('hu-hidden') > -1)
    return;
  else
    searchPage.className += ' hu-hidden';
}

/**
 * Fill search page with matching emojis
 * @param  {Array} matches Array of matching emojis
 */
HuEmoji.prototype.fillSearchPage = function(matches) {
  var emojisSearchList = this.container.querySelector('#page_Search .hu-emoji-list-items');
  emojisSearchList.innerHTML = '';
  for (var item in matches) {
    var span = document.createElement('span');
    span.className = 'hu-emoji';
    span.textContent = matches[item].value;
    span.setAttribute('data-name', matches[item].name);
    span.setAttribute('data-value', matches[item].value);
    span.addEventListener('click', this.pickEmoji.bind(this));
    span.addEventListener('mouseenter', this.previewOn.bind(this));
    span.addEventListener('mouseleave', this.previewOff.bind(this));
    var spanWrapper = document.createElement('div');
    spanWrapper.className = 'hu-emoji-item';
    spanWrapper.appendChild(span);
    emojisSearchList.appendChild(spanWrapper);
  }
  this.alignmentTrick(emojisSearchList, HuEmoji.contamination);
};

/**
 * Cancel search by deleting search value and trigger keyup
 */
HuEmoji.prototype.cancelSearch = function() {
  this.search.value = '';
  var clickEvent = document.createEvent('HTMLEvents');
  clickEvent.initEvent('keyup', false, true);
  this.search.dispatchEvent(clickEvent);
};

/**
 * Add 'c' elements in emojis 'page' to perform center alignment
 * @param  {Object} pageElem Emojis page container
 * @param  {Number} c Number of contaminating elements
 */
HuEmoji.prototype.alignmentTrick = function(pageElem, c) {
  for (var i = 0; i < c; i++) {
    var span = document.createElement('div');
    span.className = 'hu-emoji-item';
    pageElem.appendChild(span);
  }
}

/**
 * Get array of matching emojis from a search string
 * @param  {Object|Array} obj Object|Array of emojis
 * @param  {String} val Matching value
 * @return {Array} Array of matching emojis
 */
HuEmoji.prototype.getObjectsFromJSON = function(obj, val) {
  var objects = [];
  for (var i in obj) {
    if (!obj.hasOwnProperty(i)) continue;
    if (typeof obj[i] == 'object') {
      objects = objects.concat(this.getObjectsFromJSON(obj[i], val));
    } else if (obj[i].indexOf(val) > -1) {
      objects.push(obj);
    }
  }
  return objects;
}

HuEmoji.prototype.placeCaretAtEnd = function(el) {
  el.focus();
  if (typeof window.getSelection != "undefined"
      && typeof document.createRange != "undefined") {
    var range = document.createRange();
    range.selectNodeContents(el);
    range.collapse(false);
    var sel = window.getSelection();
    sel.removeAllRanges();
    sel.addRange(range);
  } else if (typeof document.body.createTextRange != "undefined") {
    var textRange = document.body.createTextRange();
    textRange.moveToElementText(el);
    textRange.collapse(false);
    textRange.select();
  }
}

/**
 * On emoji mouse click handler
 */
HuEmoji.prototype.pickEmoji = function(e) {
  var emoji = e.target.getAttribute('data-value');
  this.insertEmoji(emoji, this.input);
  if (this.input.value !== undefined)
    this.input.focus();
  else {  // CONTENTEDITABLE enters here...
    this.placeCaretAtEnd(this.input);
  }
};

/**
 * Insert emoji clicked on plugin defined input
 * @param  {String} emoji Emoji content
 * @param  {Object} input Plugin input
 */
HuEmoji.prototype.insertEmoji = function(emoji, input) {
  var startPosition, endPosition, offset = emoji.length;
  if (document.selection) {
    input.focus();
    var sel = document.selection.createRange();
    sel.text = emoji;
  } else if (input.selectionStart || input.selectionStart == '0') {
    var startPosition = input.selectionStart;
    var endPosition = input.selectionEnd;
    input.value = input.value.substring(0, startPosition) + emoji + input.value.substring(endPosition, input.value.length);
    this.triggerEvent(input, 'input');
    // Restore cursor
    input.focus();
    input.setSelectionRange(startPosition + offset, endPosition + offset);
  } else { // CONTENTEDITABLE enters here...
    if (input.value === undefined)
      input.textContent += emoji;
    else
      input.value += emoji;
    this.triggerEvent(input, 'input');
  }
}

HuEmoji.prototype.triggerEvent = function(el, type) {
  if ('createEvent' in document) {
    var e = document.createEvent('HTMLEvents');
    e.initEvent(type, false, true);
    el.dispatchEvent(e);
  } else {  // IE 8
    var e = document.createEventObject();
    e.eventType = type;
    el.fireEvent('on'+e.eventType, e);
  }
}

/**
 * Show emoji preview
 * @param  {String|Object} e Emoji hovered | Mouse click event
 */
HuEmoji.prototype.previewOn = function(e) {
  var imageElem = this.preview.querySelector('.hu-emoji-preview-image');
  var titleElem = this.preview.querySelector('.hu-emoji-preview-title');
  var nameElem = this.preview.querySelector('.hu-emoji-preview-name');
  var image = e.target || e;
  var name = image.getAttribute('data-name');
  var title = name.slice(1, name.length-1);

  imageElem.innerHTML = image.outerHTML;
  titleElem.textContent = title;
  nameElem.textContent = name;
};

/**
 * Hide emoji preview
 */
HuEmoji.prototype.previewOff = function() {
  var imageElem = this.preview.querySelector('.hu-emoji-preview-image');
  var titleElem = this.preview.querySelector('.hu-emoji-preview-title');
  var nameElem = this.preview.querySelector('.hu-emoji-preview-name');

  imageElem.innerHTML = '';
  titleElem.innerHTML = '';
  nameElem.innerHTML = '';
};


// ================================
// EMOJI PICKER BUILDER
// ================================

HuEmoji.prototype.init = function() {

  var wrapper,
      header, emojiTypes, searchElem,
      body, emojiList,
      footer, previewElem;

  // Create container
  this.container = document.createElement('div');
  this.container.className = 'hu-emoji-container';
  this.container.style.display = 'none';
  if (this.options.width)
    this.container.style.width = this.options.width;
  if (this.options.height)
    this.container.style.height = this.options.height;
  this.setContainerPosition();

  // Create wrapper
  wrapper = document.createElement('div');
  wrapper.className = 'hu-emoji-wrapper';

  // Create header
  header = document.createElement('header');
  emojiTypes = document.createElement('div');
  emojiTypes.className = 'hu-emoji-types';
  // Tabs
  this.tabs = emojiTypes;
  emojiTypes.appendChild(this.getEmojiTopbar());
  header.appendChild(emojiTypes);
  // Append search input
  if (this.options.search === true) {
    searchElem = document.createElement('div');
    searchElem.className = 'hu-emoji-search';
    var input = document.createElement('input');
    input.setAttribute('placeholder', 'Search emojis');
    // input.addEventListener('change', this.searchListener.bind(this));
    input.addEventListener('keyup', this.searchListener.bind(this));
    input.addEventListener('paste', this.searchListener.bind(this));
    searchElem.appendChild(input);
    this.search = input;
    header.appendChild(searchElem);
  }

  // Create body
  body = document.createElement('section');
  body.addEventListener('scroll', this.scrollListener.bind(this));
  var emojiListContainer = document.createElement('div');
  emojiListContainer.className = 'hu-emoji-list';
  body.appendChild(emojiListContainer);

  // Create all pages
  for (var page in this.options.pages) {
    emojiListContainer.appendChild(
      this.getEmojiPage(this.options.pages[page])
    );
  }
  // Create search page
  if (this.options.search === true) {
    emojiListContainer.appendChild(
      this.getSearchPage()
    );
  }

  // Create footer
  footer = document.createElement('footer');
  // Create preview
  if (this.options.preview === true) {
    previewElem = document.createElement('div');
    previewElem.className = 'hu-emoji-preview';
    var previewImage = document.createElement('div');
    previewImage.className = 'hu-emoji-preview-image';
    var previewInfo = document.createElement('div');
    previewInfo.className = 'hu-emoji-preview-info';
    var previewTitle = document.createElement('h4');
    previewTitle.className = 'hu-emoji-preview-title';
    var previewName = document.createElement('p');
    previewName.className = 'hu-emoji-preview-name';
    previewInfo.appendChild(previewTitle);
    previewInfo.appendChild(previewName);
    previewElem.appendChild(previewImage);
    previewElem.appendChild(previewInfo);

    this.preview = previewElem;
    footer.appendChild(previewElem);
  }

  // Mount everything
  wrapper.appendChild(header);
  wrapper.appendChild(body);
  wrapper.appendChild(footer);

  this.container.appendChild(wrapper);

  // Inject container
  this.attach.appendChild(this.container);

  this.selectPage(this.options.pages[0]);

  // Emoji picker toggler
  this.trigger.addEventListener('click', this.toggle.bind(this));

  // GLOBAL CLICK TOGGLER
  document.addEventListener('click', this.globalHide.bind(this));
};

/**
 * Build an emojis page
 * @param  {String} emojiType Page name
 * @return {Object} Emojis page HTML
 */
HuEmoji.prototype.getEmojiPage = function(emojiType) {
  var pageElem = document.createElement('div');
  pageElem.className = 'hu-emoji-list-page';
  pageElem.id = 'page_' + emojiType;

  var title = document.createElement('h3');
  title.className = 'hu-emoji-list-type';
  title.textContent = emojiType;
  pageElem.appendChild(title);

  var emojisList = document.createElement('div');
  emojisList.className = 'hu-emoji-list-items';

  for (var item in HuEmoji.EMOJIS[emojiType]) {
    var span = document.createElement('span');
    span.className = 'hu-emoji';
    span.textContent = HuEmoji.EMOJIS[emojiType][item].value;
    span.setAttribute('data-name', HuEmoji.EMOJIS[emojiType][item].name);
    span.setAttribute('data-value', HuEmoji.EMOJIS[emojiType][item].value);
    span.addEventListener('click', this.pickEmoji.bind(this));
    span.addEventListener('mouseenter', this.previewOn.bind(this));
    span.addEventListener('mouseleave', this.previewOff.bind(this));
    var spanWrapper = document.createElement('div');
    spanWrapper.className = 'hu-emoji-item';
    spanWrapper.appendChild(span);
    emojisList.appendChild(spanWrapper);
  }
  this.alignmentTrick(emojisList, HuEmoji.contamination);

  pageElem.appendChild(emojisList);
  return pageElem;
};

/**
 * Build emojis search page
 * @return {Object} Emojis page HTML
 */
HuEmoji.prototype.getSearchPage = function() {
  var pageElem = document.createElement('div');
  pageElem.className = 'hu-emoji-list-page hu-hidden';
  pageElem.id = 'page_Search';

  var title = document.createElement('h3');
  title.className = 'hu-emoji-list-type';
  title.textContent = 'Search results';
  pageElem.appendChild(title);

  var emojisList = document.createElement('div');
  emojisList.className = 'hu-emoji-list-items';

  pageElem.appendChild(emojisList);
  return pageElem;
}

/**
 * Build emojis topbar tabs
 * @return {Object} Emojis topbar tabs HTML
 */
HuEmoji.prototype.getEmojiTopbar = function() {
  var list = document.createElement('ul');
  for (var page in this.options.pages) {
    var item = document.createElement('li');
    item.setAttribute('data-tab', this.options.pages[page]);
    item.addEventListener('click', this.selectPage.bind(this));
    var content = document.createElement('div');
    content.className = 'icon hu-tab-' + this.options.pages[page];
    content.style.backgroundImage = 'url(' + this.options.spritesUrl + ')';
    item.appendChild(content);
    list.appendChild(item);
  }
  return list;
};


// ================================
// EMOJIS LIST
// ================================

HuEmoji.EMOJIS = {
  "People": [
      {
          "name": ":grinning:",
          "value": "😀"
      },
      {
          "name": ":grin:",
          "value": "😁"
      },
      {
          "name": ":joy:",
          "value": "😂"
      },
      {
          "name": ":smiley:",
          "value": "😃"
      },
      {
          "name": ":smile:",
          "value": "😄"
      },
      {
          "name": ":sweat_smile:",
          "value": "😅"
      },
      {
          "name": ":laughing:",
          "value": "😆"
      },
      {
          "name": ":innocent:",
          "value": "😇"
      },
      {
          "name": ":smiling_imp:",
          "value": "😈"
      },
      {
          "name": ":wink:",
          "value": "😉"
      },
      {
          "name": ":blush:",
          "value": "😊"
      },
      {
          "name": ":yum:",
          "value": "😋"
      },
      {
          "name": ":relieved:",
          "value": "😌"
      },
      {
          "name": ":heart_eyes:",
          "value": "😍"
      },
      {
          "name": ":sunglasses:",
          "value": "😎"
      },
      {
          "name": ":smirk:",
          "value": "😏"
      },
      {
          "name": ":neutral_face:",
          "value": "😐"
      },
      {
          "name": ":expressionless:",
          "value": "😑"
      },
      {
          "name": ":unamused:",
          "value": "😒"
      },
      {
          "name": ":sweat:",
          "value": "😓"
      },
      {
          "name": ":pensive:",
          "value": "😔"
      },
      {
          "name": ":confused:",
          "value": "😕"
      },
      {
          "name": ":confounded:",
          "value": "😖"
      },
      {
          "name": ":kissing:",
          "value": "😗"
      },
      {
          "name": ":kissing_heart:",
          "value": "😘"
      },
      {
          "name": ":kissing_smiling_eyes:",
          "value": "😙"
      },
      {
          "name": ":kissing_closed_eyes:",
          "value": "😚"
      },
      {
          "name": ":stuck_out_tongue:",
          "value": "😛"
      },
      {
          "name": ":stuck_out_tongue_winking_eye:",
          "value": "😜"
      },
      {
          "name": ":stuck_out_tongue_closed_eyes:",
          "value": "😝"
      },
      {
          "name": ":disappointed:",
          "value": "😞"
      },
      {
          "name": ":worried:",
          "value": "😟"
      },
      {
          "name": ":angry:",
          "value": "😠"
      },
      {
          "name": ":rage:",
          "value": "😡"
      },
      {
          "name": ":cry:",
          "value": "😢"
      },
      {
          "name": ":persevere:",
          "value": "😣"
      },
      {
          "name": ":triumph:",
          "value": "😤"
      },
      {
          "name": ":disappointed_relieved:",
          "value": "😥"
      },
      {
          "name": ":frowning:",
          "value": "😦"
      },
      {
          "name": ":anguished:",
          "value": "😧"
      },
      {
          "name": ":fearful:",
          "value": "😨"
      },
      {
          "name": ":weary:",
          "value": "😩"
      },
      {
          "name": ":sleepy:",
          "value": "😪"
      },
      {
          "name": ":tired_face:",
          "value": "😫"
      },
      {
          "name": ":grimacing:",
          "value": "😬"
      },
      {
          "name": ":sob:",
          "value": "😭"
      },
      {
          "name": ":open_mouth:",
          "value": "😮"
      },
      {
          "name": ":hushed:",
          "value": "😯"
      },
      {
          "name": ":cold_sweat:",
          "value": "😰"
      },
      {
          "name": ":scream:",
          "value": "😱"
      },
      {
          "name": ":astonished:",
          "value": "😲"
      },
      {
          "name": ":flushed:",
          "value": "😳"
      },
      {
          "name": ":sleeping:",
          "value": "😴"
      },
      {
          "name": ":dizzy_face:",
          "value": "😵"
      },
      {
          "name": ":no_mouth:",
          "value": "😶"
      },
      {
          "name": ":mask:",
          "value": "😷"
      },
      {
          "name": ":smile_cat:",
          "value": "😸"
      },
      {
          "name": ":joy_cat:",
          "value": "😹"
      },
      {
          "name": ":smiley_cat:",
          "value": "😺"
      },
      {
          "name": ":heart_eyes_cat:",
          "value": "😻"
      },
      {
          "name": ":smirk_cat:",
          "value": "😼"
      },
      {
          "name": ":kissing_cat:",
          "value": "😽"
      },
      {
          "name": ":pouting_cat:",
          "value": "😾"
      },
      {
          "name": ":crying_cat_face:",
          "value": "😿"
      },
      {
          "name": ":scream_cat:",
          "value": "🙀"
      },
      {
          "name": ":slightly_frowning_face:",
          "value": "🙁"
      },
      {
          "name": ":slightly_smiling_face:",
          "value": "🙂"
      },
      {
          "name": ":upside_down_face:",
          "value": "🙃"
      },
      {
          "name": ":face_with_rolling_eyes:",
          "value": "🙄"
      },
      {
          "name": ":no_good:",
          "value": "🙅"
      },
      {
          "name": ":ok_woman:",
          "value": "🙆"
      },
      {
          "name": ":bow:",
          "value": "🙇"
      },
      {
          "name": ":see_no_evil:",
          "value": "🙈"
      },
      {
          "name": ":hear_no_evil:",
          "value": "🙉"
      },
      {
          "name": ":speak_no_evil:",
          "value": "🙊"
      },
      {
          "name": ":raising_hand:",
          "value": "🙋"
      },
      {
          "name": ":raised_hands:",
          "value": "🙌"
      },
      {
          "name": ":person_frowning:",
          "value": "🙍"
      },
      {
          "name": ":person_with_pouting_face:",
          "value": "🙎"
      },
      {
          "name": ":pray:",
          "value": "🙏"
      },
      {
          "name": ":rowboat:",
          "value": "🚣"
      },
      {
          "name": ":bicyclist:",
          "value": "🚴"
      },
      {
          "name": ":mountain_bicyclist:",
          "value": "🚵"
      },
      {
          "name": ":walking:",
          "value": "🚶"
      },
      {
          "name": ":shopping_bags:",
          "value": "🛍"
      },
      {
          "name": ":zipper_mouth_face:",
          "value": "🤐"
      },
      {
          "name": ":money_mouth_face:",
          "value": "🤑"
      },
      {
          "name": ":face_with_thermometer:",
          "value": "🤒"
      },
      {
          "name": ":nerd_face:",
          "value": "🤓"
      },
      {
          "name": ":thinking_face:",
          "value": "🤔"
      },
      {
          "name": ":face_with_head_bandage:",
          "value": "🤕"
      },
      {
          "name": ":robot_face:",
          "value": "🤖"
      },
      {
          "name": ":hugging_face:",
          "value": "🤗"
      },
      {
          "name": ":the_horns:",
          "value": "🤘"
      },
      {
          "name": ":man-man-boy:",
          "value": "👨‍👨‍👦"
      },
      {
          "name": ":man-man-boy-boy:",
          "value": "👨‍👨‍👦‍👦"
      },
      {
          "name": ":man-man-girl:",
          "value": "👨‍👨‍👧"
      },
      {
          "name": ":man-man-girl-boy:",
          "value": "👨‍👨‍👧‍👦"
      },
      {
          "name": ":man-man-girl-girl:",
          "value": "👨‍👨‍👧‍👧"
      },
      {
          "name": ":man-woman-boy-boy:",
          "value": "👨‍👩‍👦‍👦"
      },
      {
          "name": ":man-woman-girl:",
          "value": "👨‍👩‍👧"
      },
      {
          "name": ":man-woman-girl-boy:",
          "value": "👨‍👩‍👧‍👦"
      },
      {
          "name": ":man-woman-girl-girl:",
          "value": "👨‍👩‍👧‍👧"
      },
      {
          "name": ":man-heart-man:",
          "value": "👨‍❤️‍👨"
      },
      {
          "name": ":man-kiss-man:",
          "value": "👨‍❤️‍💋‍👨"
      },
      {
          "name": ":woman-woman-boy:",
          "value": "👩‍👩‍👦"
      },
      {
          "name": ":woman-woman-boy-boy:",
          "value": "👩‍👩‍👦‍👦"
      },
      {
          "name": ":woman-woman-girl:",
          "value": "👩‍👩‍👧"
      },
      {
          "name": ":woman-woman-girl-boy:",
          "value": "👩‍👩‍👧‍👦"
      },
      {
          "name": ":woman-woman-girl-girl:",
          "value": "👩‍👩‍👧‍👧"
      },
      {
          "name": ":woman-heart-woman:",
          "value": "👩‍❤️‍👩"
      },
      {
          "name": ":woman-kiss-woman:",
          "value": "👩‍❤️‍💋‍👩"
      },
      {
          "name": ":umbrella:",
          "value": "☂"
      },
      {
          "name": ":umbrella_with_rain_drops:",
          "value": "☔"
      },
      {
          "name": ":point_up:",
          "value": "☝"
      },
      {
          "name": ":skull_and_crossbones:",
          "value": "☠"
      },
      {
          "name": ":white_frowning_face:",
          "value": "☹"
      },
      {
          "name": ":relaxed:",
          "value": "☺"
      },
      {
          "name": ":spades:",
          "value": "♠"
      },
      {
          "name": ":clubs:",
          "value": "♣"
      },
      {
          "name": ":hearts:",
          "value": "♥"
      },
      {
          "name": ":diamonds:",
          "value": "♦"
      },
      {
          "name": ":helmet_with_white_cross:",
          "value": "⛑"
      },
      {
          "name": ":umbrella_on_ground:",
          "value": "⛱"
      },
      {
          "name": ":skier:",
          "value": "⛷"
      },
      {
          "name": ":person_with_ball:",
          "value": "⛹"
      },
      {
          "name": ":fist:",
          "value": "✊"
      },
      {
          "name": ":hand:",
          "value": "✋"
      },
      {
          "name": ":v:",
          "value": "✌"
      },
      {
          "name": ":writing_hand:",
          "value": "✍"
      },
      {
          "name": ":sparkles:",
          "value": "✨"
      },
      {
          "name": ":mahjong:",
          "value": "🀄"
      },
      {
          "name": ":black_joker:",
          "value": "🃏"
      },
      {
          "name": ":cyclone:",
          "value": "🌀"
      },
      {
          "name": ":closed_umbrella:",
          "value": "🌂"
      },
      {
          "name": ":stars:",
          "value": "🌠"
      },
      {
          "name": ":thermometer:",
          "value": "🌡"
      },
      {
          "name": ":jack_o_lantern:",
          "value": "🎃"
      },
      {
          "name": ":christmas_tree:",
          "value": "🎄"
      },
      {
          "name": ":santa:",
          "value": "🎅"
      },
      {
          "name": ":fireworks:",
          "value": "🎆"
      },
      {
          "name": ":sparkler:",
          "value": "🎇"
      },
      {
          "name": ":school_satchel:",
          "value": "🎒"
      },
      {
          "name": ":mortar_board:",
          "value": "🎓"
      },
      {
          "name": ":art:",
          "value": "🎨"
      },
      {
          "name": ":tophat:",
          "value": "🎩"
      },
      {
          "name": ":circus_tent:",
          "value": "🎪"
      },
      {
          "name": ":performing_arts:",
          "value": "🎭"
      },
      {
          "name": ":slot_machine:",
          "value": "🎰"
      },
      {
          "name": ":flower_playing_cards:",
          "value": "🎴"
      },
      {
          "name": ":snowboarder:",
          "value": "🏂"
      },
      {
          "name": ":runner:",
          "value": "🏃"
      },
      {
          "name": ":surfer:",
          "value": "🏄"
      },
      {
          "name": ":horse_racing:",
          "value": "🏇"
      },
      {
          "name": ":swimmer:",
          "value": "🏊"
      },
      {
          "name": ":weight_lifter:",
          "value": "🏋"
      },
      {
          "name": ":golfer:",
          "value": "🏌"
      },
      {
          "name": ":racing_motorcycle:",
          "value": "🏍"
      },
      {
          "name": ":racing_car:",
          "value": "🏎"
      },
      {
          "name": ":amphora:",
          "value": "🏺"
      },
      {
          "name": ":skin-tone-2:",
          "value": "🏻"
      },
      {
          "name": ":skin-tone-3:",
          "value": "🏼"
      },
      {
          "name": ":skin-tone-4:",
          "value": "🏽"
      },
      {
          "name": ":skin-tone-5:",
          "value": "🏾"
      },
      {
          "name": ":skin-tone-6:",
          "value": "🏿"
      },
      {
          "name": ":eyes:",
          "value": "👀"
      },
      {
          "name": ":eye:",
          "value": "👁"
      },
      {
          "name": ":ear:",
          "value": "👂"
      },
      {
          "name": ":nose:",
          "value": "👃"
      },
      {
          "name": ":lips:",
          "value": "👄"
      },
      {
          "name": ":tongue:",
          "value": "👅"
      },
      {
          "name": ":point_up_2:",
          "value": "👆"
      },
      {
          "name": ":point_down:",
          "value": "👇"
      },
      {
          "name": ":point_left:",
          "value": "👈"
      },
      {
          "name": ":point_right:",
          "value": "👉"
      },
      {
          "name": ":facepunch:",
          "value": "👊"
      },
      {
          "name": ":wave:",
          "value": "👋"
      },
      {
          "name": ":ok_hand:",
          "value": "👌"
      },
      {
          "name": ":+1:",
          "value": "👍"
      },
      {
          "name": ":-1:",
          "value": "👎"
      },
      {
          "name": ":clap:",
          "value": "👏"
      },
      {
          "name": ":open_hands:",
          "value": "👐"
      },
      {
          "name": ":crown:",
          "value": "👑"
      },
      {
          "name": ":womans_hat:",
          "value": "👒"
      },
      {
          "name": ":eyeglasses:",
          "value": "👓"
      },
      {
          "name": ":necktie:",
          "value": "👔"
      },
      {
          "name": ":shirt:",
          "value": "👕"
      },
      {
          "name": ":jeans:",
          "value": "👖"
      },
      {
          "name": ":dress:",
          "value": "👗"
      },
      {
          "name": ":kimono:",
          "value": "👘"
      },
      {
          "name": ":bikini:",
          "value": "👙"
      },
      {
          "name": ":womans_clothes:",
          "value": "👚"
      },
      {
          "name": ":purse:",
          "value": "👛"
      },
      {
          "name": ":handbag:",
          "value": "👜"
      },
      {
          "name": ":pouch:",
          "value": "👝"
      },
      {
          "name": ":mans_shoe:",
          "value": "👞"
      },
      {
          "name": ":athletic_shoe:",
          "value": "👟"
      },
      {
          "name": ":high_heel:",
          "value": "👠"
      },
      {
          "name": ":sandal:",
          "value": "👡"
      },
      {
          "name": ":boot:",
          "value": "👢"
      },
      {
          "name": ":footprints:",
          "value": "👣"
      },
      {
          "name": ":bust_in_silhouette:",
          "value": "👤"
      },
      {
          "name": ":busts_in_silhouette:",
          "value": "👥"
      },
      {
          "name": ":boy:",
          "value": "👦"
      },
      {
          "name": ":girl:",
          "value": "👧"
      },
      {
          "name": ":man:",
          "value": "👨"
      },
      {
          "name": ":woman:",
          "value": "👩"
      },
      {
          "name": ":family:",
          "value": "👪"
      },
      {
          "name": ":couple:",
          "value": "👫"
      },
      {
          "name": ":two_men_holding_hands:",
          "value": "👬"
      },
      {
          "name": ":two_women_holding_hands:",
          "value": "👭"
      },
      {
          "name": ":cop:",
          "value": "👮"
      },
      {
          "name": ":dancers:",
          "value": "👯"
      },
      {
          "name": ":bride_with_veil:",
          "value": "👰"
      },
      {
          "name": ":person_with_blond_hair:",
          "value": "👱"
      },
      {
          "name": ":man_with_gua_pi_mao:",
          "value": "👲"
      },
      {
          "name": ":man_with_turban:",
          "value": "👳"
      },
      {
          "name": ":older_man:",
          "value": "👴"
      },
      {
          "name": ":older_woman:",
          "value": "👵"
      },
      {
          "name": ":baby:",
          "value": "👶"
      },
      {
          "name": ":construction_worker:",
          "value": "👷"
      },
      {
          "name": ":princess:",
          "value": "👸"
      },
      {
          "name": ":japanese_ogre:",
          "value": "👹"
      },
      {
          "name": ":japanese_goblin:",
          "value": "👺"
      },
      {
          "name": ":ghost:",
          "value": "👻"
      },
      {
          "name": ":angel:",
          "value": "👼"
      },
      {
          "name": ":alien:",
          "value": "👽"
      },
      {
          "name": ":space_invader:",
          "value": "👾"
      },
      {
          "name": ":imp:",
          "value": "👿"
      },
      {
          "name": ":skull:",
          "value": "💀"
      },
      {
          "name": ":information_desk_person:",
          "value": "💁"
      },
      {
          "name": ":guardsman:",
          "value": "💂"
      },
      {
          "name": ":dancer:",
          "value": "💃"
      },
      {
          "name": ":lipstick:",
          "value": "💄"
      },
      {
          "name": ":nail_care:",
          "value": "💅"
      },
      {
          "name": ":massage:",
          "value": "💆"
      },
      {
          "name": ":haircut:",
          "value": "💇"
      },
      {
          "name": ":barber:",
          "value": "💈"
      },
      {
          "name": ":kiss:",
          "value": "💋"
      },
      {
          "name": ":love_letter:",
          "value": "💌"
      },
      {
          "name": ":ring:",
          "value": "💍"
      },
      {
          "name": ":gem:",
          "value": "💎"
      },
      {
          "name": ":couplekiss:",
          "value": "💏"
      },
      {
          "name": ":couple_with_heart:",
          "value": "💑"
      },
      {
          "name": ":anger:",
          "value": "💢"
      },
      {
          "name": ":bomb:",
          "value": "💣"
      },
      {
          "name": ":zzz:",
          "value": "💤"
      },
      {
          "name": ":boom:",
          "value": "💥"
      },
      {
          "name": ":sweat_drops:",
          "value": "💦"
      },
      {
          "name": ":dash:",
          "value": "💨"
      },
      {
          "name": ":hankey:",
          "value": "💩"
      },
      {
          "name": ":muscle:",
          "value": "💪"
      },
      {
          "name": ":dizzy:",
          "value": "💫"
      },
      {
          "name": ":currency_exchange:",
          "value": "💱"
      },
      {
          "name": ":heavy_dollar_sign:",
          "value": "💲"
      },
      {
          "name": ":chart:",
          "value": "💹"
      },
      {
          "name": ":prayer_beads:",
          "value": "📿"
      },
      {
          "name": ":hole:",
          "value": "🕳"
      },
      {
          "name": ":man_in_business_suit_levitating:",
          "value": "🕴"
      },
      {
          "name": ":sleuth_or_spy:",
          "value": "🕵"
      },
      {
          "name": ":dark_sunglasses:",
          "value": "🕶"
      },
      {
          "name": ":raised_hand_with_fingers_splayed:",
          "value": "🖐"
      },
      {
          "name": ":middle_finger:",
          "value": "🖕"
      },
      {
          "name": ":spock-hand:",
          "value": "🖖"
      },
      {
          "name": ":frame_with_picture:",
          "value": "🖼"
      },
      {
          "name": ":speaking_head_in_silhouette:",
          "value": "🗣"
      }
  ],
  "Nature": [
      {
          "name": ":sunny:",
          "value": "☀"
      },
      {
          "name": ":cloud:",
          "value": "☁"
      },
      {
          "name": ":snowman:",
          "value": "☃"
      },
      {
          "name": ":comet:",
          "value": "☄"
      },
      {
          "name": ":shamrock:",
          "value": "☘"
      },
      {
          "name": ":zap:",
          "value": "⚡"
      },
      {
          "name": ":snowman_without_snow:",
          "value": "⛄"
      },
      {
          "name": ":partly_sunny:",
          "value": "⛅"
      },
      {
          "name": ":thunder_cloud_and_rain:",
          "value": "⛈"
      },
      {
          "name": ":snowflake:",
          "value": "❄"
      },
      {
          "name": ":star:",
          "value": "⭐"
      },
      {
          "name": ":rainbow:",
          "value": "🌈"
      },
      {
          "name": ":ocean:",
          "value": "🌊"
      },
      {
          "name": ":earth_africa:",
          "value": "🌍"
      },
      {
          "name": ":earth_americas:",
          "value": "🌎"
      },
      {
          "name": ":earth_asia:",
          "value": "🌏"
      },
      {
          "name": ":new_moon:",
          "value": "🌑"
      },
      {
          "name": ":waxing_crescent_moon:",
          "value": "🌒"
      },
      {
          "name": ":first_quarter_moon:",
          "value": "🌓"
      },
      {
          "name": ":moon:",
          "value": "🌔"
      },
      {
          "name": ":full_moon:",
          "value": "🌕"
      },
      {
          "name": ":waning_gibbous_moon:",
          "value": "🌖"
      },
      {
          "name": ":last_quarter_moon:",
          "value": "🌗"
      },
      {
          "name": ":waning_crescent_moon:",
          "value": "🌘"
      },
      {
          "name": ":crescent_moon:",
          "value": "🌙"
      },
      {
          "name": ":new_moon_with_face:",
          "value": "🌚"
      },
      {
          "name": ":first_quarter_moon_with_face:",
          "value": "🌛"
      },
      {
          "name": ":last_quarter_moon_with_face:",
          "value": "🌜"
      },
      {
          "name": ":full_moon_with_face:",
          "value": "🌝"
      },
      {
          "name": ":sun_with_face:",
          "value": "🌞"
      },
      {
          "name": ":star2:",
          "value": "🌟"
      },
      {
          "name": ":mostly_sunny:",
          "value": "🌤"
      },
      {
          "name": ":barely_sunny:",
          "value": "🌥"
      },
      {
          "name": ":partly_sunny_rain:",
          "value": "🌦"
      },
      {
          "name": ":rain_cloud:",
          "value": "🌧"
      },
      {
          "name": ":snow_cloud:",
          "value": "🌨"
      },
      {
          "name": ":lightning:",
          "value": "🌩"
      },
      {
          "name": ":tornado:",
          "value": "🌪"
      },
      {
          "name": ":fog:",
          "value": "🌫"
      },
      {
          "name": ":wind_blowing_face:",
          "value": "🌬"
      },
      {
          "name": ":seedling:",
          "value": "🌱"
      },
      {
          "name": ":evergreen_tree:",
          "value": "🌲"
      },
      {
          "name": ":deciduous_tree:",
          "value": "🌳"
      },
      {
          "name": ":palm_tree:",
          "value": "🌴"
      },
      {
          "name": ":cactus:",
          "value": "🌵"
      },
      {
          "name": ":tulip:",
          "value": "🌷"
      },
      {
          "name": ":cherry_blossom:",
          "value": "🌸"
      },
      {
          "name": ":rose:",
          "value": "🌹"
      },
      {
          "name": ":hibiscus:",
          "value": "🌺"
      },
      {
          "name": ":sunflower:",
          "value": "🌻"
      },
      {
          "name": ":blossom:",
          "value": "🌼"
      },
      {
          "name": ":ear_of_rice:",
          "value": "🌾"
      },
      {
          "name": ":herb:",
          "value": "🌿"
      },
      {
          "name": ":four_leaf_clover:",
          "value": "🍀"
      },
      {
          "name": ":maple_leaf:",
          "value": "🍁"
      },
      {
          "name": ":fallen_leaf:",
          "value": "🍂"
      },
      {
          "name": ":leaves:",
          "value": "🍃"
      },
      {
          "name": ":rosette:",
          "value": "🏵"
      },
      {
          "name": ":rat:",
          "value": "🐀"
      },
      {
          "name": ":mouse2:",
          "value": "🐁"
      },
      {
          "name": ":ox:",
          "value": "🐂"
      },
      {
          "name": ":water_buffalo:",
          "value": "🐃"
      },
      {
          "name": ":cow2:",
          "value": "🐄"
      },
      {
          "name": ":tiger2:",
          "value": "🐅"
      },
      {
          "name": ":leopard:",
          "value": "🐆"
      },
      {
          "name": ":rabbit2:",
          "value": "🐇"
      },
      {
          "name": ":cat2:",
          "value": "🐈"
      },
      {
          "name": ":dragon:",
          "value": "🐉"
      },
      {
          "name": ":crocodile:",
          "value": "🐊"
      },
      {
          "name": ":whale2:",
          "value": "🐋"
      },
      {
          "name": ":snail:",
          "value": "🐌"
      },
      {
          "name": ":snake:",
          "value": "🐍"
      },
      {
          "name": ":racehorse:",
          "value": "🐎"
      },
      {
          "name": ":ram:",
          "value": "🐏"
      },
      {
          "name": ":goat:",
          "value": "🐐"
      },
      {
          "name": ":sheep:",
          "value": "🐑"
      },
      {
          "name": ":monkey:",
          "value": "🐒"
      },
      {
          "name": ":rooster:",
          "value": "🐓"
      },
      {
          "name": ":chicken:",
          "value": "🐔"
      },
      {
          "name": ":dog2:",
          "value": "🐕"
      },
      {
          "name": ":pig2:",
          "value": "🐖"
      },
      {
          "name": ":boar:",
          "value": "🐗"
      },
      {
          "name": ":elephant:",
          "value": "🐘"
      },
      {
          "name": ":octopus:",
          "value": "🐙"
      },
      {
          "name": ":shell:",
          "value": "🐚"
      },
      {
          "name": ":bug:",
          "value": "🐛"
      },
      {
          "name": ":ant:",
          "value": "🐜"
      },
      {
          "name": ":bee:",
          "value": "🐝"
      },
      {
          "name": ":beetle:",
          "value": "🐞"
      },
      {
          "name": ":fish:",
          "value": "🐟"
      },
      {
          "name": ":tropical_fish:",
          "value": "🐠"
      },
      {
          "name": ":blowfish:",
          "value": "🐡"
      },
      {
          "name": ":turtle:",
          "value": "🐢"
      },
      {
          "name": ":hatching_chick:",
          "value": "🐣"
      },
      {
          "name": ":baby_chick:",
          "value": "🐤"
      },
      {
          "name": ":hatched_chick:",
          "value": "🐥"
      },
      {
          "name": ":bird:",
          "value": "🐦"
      },
      {
          "name": ":penguin:",
          "value": "🐧"
      },
      {
          "name": ":koala:",
          "value": "🐨"
      },
      {
          "name": ":poodle:",
          "value": "🐩"
      },
      {
          "name": ":dromedary_camel:",
          "value": "🐪"
      },
      {
          "name": ":camel:",
          "value": "🐫"
      },
      {
          "name": ":dolphin:",
          "value": "🐬"
      },
      {
          "name": ":mouse:",
          "value": "🐭"
      },
      {
          "name": ":cow:",
          "value": "🐮"
      },
      {
          "name": ":tiger:",
          "value": "🐯"
      },
      {
          "name": ":rabbit:",
          "value": "🐰"
      },
      {
          "name": ":cat:",
          "value": "🐱"
      },
      {
          "name": ":dragon_face:",
          "value": "🐲"
      },
      {
          "name": ":whale:",
          "value": "🐳"
      },
      {
          "name": ":horse:",
          "value": "🐴"
      },
      {
          "name": ":monkey_face:",
          "value": "🐵"
      },
      {
          "name": ":dog:",
          "value": "🐶"
      },
      {
          "name": ":pig:",
          "value": "🐷"
      },
      {
          "name": ":frog:",
          "value": "🐸"
      },
      {
          "name": ":hamster:",
          "value": "🐹"
      },
      {
          "name": ":wolf:",
          "value": "🐺"
      },
      {
          "name": ":bear:",
          "value": "🐻"
      },
      {
          "name": ":panda_face:",
          "value": "🐼"
      },
      {
          "name": ":pig_nose:",
          "value": "🐽"
      },
      {
          "name": ":feet:",
          "value": "🐾"
      },
      {
          "name": ":chipmunk:",
          "value": "🐿"
      },
      {
          "name": ":bouquet:",
          "value": "💐"
      },
      {
          "name": ":droplet:",
          "value": "💧"
      },
      {
          "name": ":white_flower:",
          "value": "💮"
      },
      {
          "name": ":fire:",
          "value": "🔥"
      },
      {
          "name": ":dove_of_peace:",
          "value": "🕊"
      },
      {
          "name": ":spider:",
          "value": "🕷"
      },
      {
          "name": ":spider_web:",
          "value": "🕸"
      },
      {
          "name": ":crab:",
          "value": "🦀"
      },
      {
          "name": ":lion_face:",
          "value": "🦁"
      },
      {
          "name": ":scorpion:",
          "value": "🦂"
      },
      {
          "name": ":turkey:",
          "value": "🦃"
      },
      {
          "name": ":unicorn_face:",
          "value": "🦄"
      }
  ],
  "Food": [
      {
          "name": ":coffee:",
          "value": "☕"
      },
      {
          "name": ":hotdog:",
          "value": "🌭"
      },
      {
          "name": ":taco:",
          "value": "🌮"
      },
      {
          "name": ":burrito:",
          "value": "🌯"
      },
      {
          "name": ":chestnut:",
          "value": "🌰"
      },
      {
          "name": ":hot_pepper:",
          "value": "🌶"
      },
      {
          "name": ":corn:",
          "value": "🌽"
      },
      {
          "name": ":mushroom:",
          "value": "🍄"
      },
      {
          "name": ":tomato:",
          "value": "🍅"
      },
      {
          "name": ":eggplant:",
          "value": "🍆"
      },
      {
          "name": ":grapes:",
          "value": "🍇"
      },
      {
          "name": ":melon:",
          "value": "🍈"
      },
      {
          "name": ":watermelon:",
          "value": "🍉"
      },
      {
          "name": ":tangerine:",
          "value": "🍊"
      },
      {
          "name": ":lemon:",
          "value": "🍋"
      },
      {
          "name": ":banana:",
          "value": "🍌"
      },
      {
          "name": ":pineapple:",
          "value": "🍍"
      },
      {
          "name": ":apple:",
          "value": "🍎"
      },
      {
          "name": ":green_apple:",
          "value": "🍏"
      },
      {
          "name": ":pear:",
          "value": "🍐"
      },
      {
          "name": ":peach:",
          "value": "🍑"
      },
      {
          "name": ":cherries:",
          "value": "🍒"
      },
      {
          "name": ":strawberry:",
          "value": "🍓"
      },
      {
          "name": ":hamburger:",
          "value": "🍔"
      },
      {
          "name": ":pizza:",
          "value": "🍕"
      },
      {
          "name": ":meat_on_bone:",
          "value": "🍖"
      },
      {
          "name": ":poultry_leg:",
          "value": "🍗"
      },
      {
          "name": ":rice_cracker:",
          "value": "🍘"
      },
      {
          "name": ":rice_ball:",
          "value": "🍙"
      },
      {
          "name": ":rice:",
          "value": "🍚"
      },
      {
          "name": ":curry:",
          "value": "🍛"
      },
      {
          "name": ":ramen:",
          "value": "🍜"
      },
      {
          "name": ":spaghetti:",
          "value": "🍝"
      },
      {
          "name": ":bread:",
          "value": "🍞"
      },
      {
          "name": ":fries:",
          "value": "🍟"
      },
      {
          "name": ":sweet_potato:",
          "value": "🍠"
      },
      {
          "name": ":dango:",
          "value": "🍡"
      },
      {
          "name": ":oden:",
          "value": "🍢"
      },
      {
          "name": ":sushi:",
          "value": "🍣"
      },
      {
          "name": ":fried_shrimp:",
          "value": "🍤"
      },
      {
          "name": ":fish_cake:",
          "value": "🍥"
      },
      {
          "name": ":icecream:",
          "value": "🍦"
      },
      {
          "name": ":shaved_ice:",
          "value": "🍧"
      },
      {
          "name": ":ice_cream:",
          "value": "🍨"
      },
      {
          "name": ":doughnut:",
          "value": "🍩"
      },
      {
          "name": ":cookie:",
          "value": "🍪"
      },
      {
          "name": ":chocolate_bar:",
          "value": "🍫"
      },
      {
          "name": ":candy:",
          "value": "🍬"
      },
      {
          "name": ":lollipop:",
          "value": "🍭"
      },
      {
          "name": ":custard:",
          "value": "🍮"
      },
      {
          "name": ":honey_pot:",
          "value": "🍯"
      },
      {
          "name": ":cake:",
          "value": "🍰"
      },
      {
          "name": ":bento:",
          "value": "🍱"
      },
      {
          "name": ":stew:",
          "value": "🍲"
      },
      {
          "name": ":egg:",
          "value": "🍳"
      },
      {
          "name": ":fork_and_knife:",
          "value": "🍴"
      },
      {
          "name": ":tea:",
          "value": "🍵"
      },
      {
          "name": ":sake:",
          "value": "🍶"
      },
      {
          "name": ":wine_glass:",
          "value": "🍷"
      },
      {
          "name": ":cocktail:",
          "value": "🍸"
      },
      {
          "name": ":tropical_drink:",
          "value": "🍹"
      },
      {
          "name": ":beer:",
          "value": "🍺"
      },
      {
          "name": ":beers:",
          "value": "🍻"
      },
      {
          "name": ":baby_bottle:",
          "value": "🍼"
      },
      {
          "name": ":knife_fork_plate:",
          "value": "🍽"
      },
      {
          "name": ":champagne:",
          "value": "🍾"
      },
      {
          "name": ":popcorn:",
          "value": "🍿"
      },
      {
          "name": ":birthday:",
          "value": "🎂"
      },
      {
          "name": ":hocho:",
          "value": "🔪"
      },
      {
          "name": ":cheese_wedge:",
          "value": "🧀"
      }
  ],
  "Activity": [
      {
          "name": ":soccer:",
          "value": "⚽"
      },
      {
          "name": ":baseball:",
          "value": "⚾"
      },
      {
          "name": ":golf:",
          "value": "⛳"
      },
      {
          "name": ":ice_skate:",
          "value": "⛸"
      },
      {
          "name": ":medal:",
          "value": "🎖"
      },
      {
          "name": ":fishing_pole_and_fish:",
          "value": "🎣"
      },
      {
          "name": ":video_game:",
          "value": "🎮"
      },
      {
          "name": ":dart:",
          "value": "🎯"
      },
      {
          "name": ":8ball:",
          "value": "🎱"
      },
      {
          "name": ":game_die:",
          "value": "🎲"
      },
      {
          "name": ":bowling:",
          "value": "🎳"
      },
      {
          "name": ":running_shirt_with_sash:",
          "value": "🎽"
      },
      {
          "name": ":tennis:",
          "value": "🎾"
      },
      {
          "name": ":ski:",
          "value": "🎿"
      },
      {
          "name": ":basketball:",
          "value": "🏀"
      },
      {
          "name": ":sports_medal:",
          "value": "🏅"
      },
      {
          "name": ":trophy:",
          "value": "🏆"
      },
      {
          "name": ":football:",
          "value": "🏈"
      },
      {
          "name": ":rugby_football:",
          "value": "🏉"
      },
      {
          "name": ":cricket_bat_and_ball:",
          "value": "🏏"
      },
      {
          "name": ":volleyball:",
          "value": "🏐"
      },
      {
          "name": ":field_hockey_stick_and_ball:",
          "value": "🏑"
      },
      {
          "name": ":ice_hockey_stick_and_puck:",
          "value": "🏒"
      },
      {
          "name": ":table_tennis_paddle_and_ball:",
          "value": "🏓"
      },
      {
          "name": ":badminton_racquet_and_shuttlecock:",
          "value": "🏸"
      },
      {
          "name": ":joystick:",
          "value": "🕹"
      }
  ],
  "Travel": [
      {
          "name": ":hotsprings:",
          "value": "♨"
      },
      {
          "name": ":anchor:",
          "value": "⚓"
      },
      {
          "name": ":shinto_shrine:",
          "value": "⛩"
      },
      {
          "name": ":church:",
          "value": "⛪"
      },
      {
          "name": ":mountain:",
          "value": "⛰"
      },
      {
          "name": ":fountain:",
          "value": "⛲"
      },
      {
          "name": ":ferry:",
          "value": "⛴"
      },
      {
          "name": ":boat:",
          "value": "⛵"
      },
      {
          "name": ":tent:",
          "value": "⛺"
      },
      {
          "name": ":fuelpump:",
          "value": "⛽"
      },
      {
          "name": ":airplane:",
          "value": "✈"
      },
      {
          "name": ":foggy:",
          "value": "🌁"
      },
      {
          "name": ":night_with_stars:",
          "value": "🌃"
      },
      {
          "name": ":sunrise_over_mountains:",
          "value": "🌄"
      },
      {
          "name": ":sunrise:",
          "value": "🌅"
      },
      {
          "name": ":city_sunset:",
          "value": "🌆"
      },
      {
          "name": ":city_sunrise:",
          "value": "🌇"
      },
      {
          "name": ":bridge_at_night:",
          "value": "🌉"
      },
      {
          "name": ":volcano:",
          "value": "🌋"
      },
      {
          "name": ":milky_way:",
          "value": "🌌"
      },
      {
          "name": ":globe_with_meridians:",
          "value": "🌐"
      },
      {
          "name": ":carousel_horse:",
          "value": "🎠"
      },
      {
          "name": ":ferris_wheel:",
          "value": "🎡"
      },
      {
          "name": ":roller_coaster:",
          "value": "🎢"
      },
      {
          "name": ":snow_capped_mountain:",
          "value": "🏔"
      },
      {
          "name": ":camping:",
          "value": "🏕"
      },
      {
          "name": ":beach_with_umbrella:",
          "value": "🏖"
      },
      {
          "name": ":building_construction:",
          "value": "🏗"
      },
      {
          "name": ":house_buildings:",
          "value": "🏘"
      },
      {
          "name": ":cityscape:",
          "value": "🏙"
      },
      {
          "name": ":derelict_house_building:",
          "value": "🏚"
      },
      {
          "name": ":classical_building:",
          "value": "🏛"
      },
      {
          "name": ":desert:",
          "value": "🏜"
      },
      {
          "name": ":desert_island:",
          "value": "🏝"
      },
      {
          "name": ":national_park:",
          "value": "🏞"
      },
      {
          "name": ":stadium:",
          "value": "🏟"
      },
      {
          "name": ":house:",
          "value": "🏠"
      },
      {
          "name": ":house_with_garden:",
          "value": "🏡"
      },
      {
          "name": ":office:",
          "value": "🏢"
      },
      {
          "name": ":post_office:",
          "value": "🏣"
      },
      {
          "name": ":european_post_office:",
          "value": "🏤"
      },
      {
          "name": ":hospital:",
          "value": "🏥"
      },
      {
          "name": ":bank:",
          "value": "🏦"
      },
      {
          "name": ":hotel:",
          "value": "🏨"
      },
      {
          "name": ":love_hotel:",
          "value": "🏩"
      },
      {
          "name": ":convenience_store:",
          "value": "🏪"
      },
      {
          "name": ":school:",
          "value": "🏫"
      },
      {
          "name": ":department_store:",
          "value": "🏬"
      },
      {
          "name": ":factory:",
          "value": "🏭"
      },
      {
          "name": ":japanese_castle:",
          "value": "🏯"
      },
      {
          "name": ":european_castle:",
          "value": "🏰"
      },
      {
          "name": ":wedding:",
          "value": "💒"
      },
      {
          "name": ":seat:",
          "value": "💺"
      },
      {
          "name": ":kaaba:",
          "value": "🕋"
      },
      {
          "name": ":mosque:",
          "value": "🕌"
      },
      {
          "name": ":synagogue:",
          "value": "🕍"
      },
      {
          "name": ":world_map:",
          "value": "🗺"
      },
      {
          "name": ":mount_fuji:",
          "value": "🗻"
      },
      {
          "name": ":tokyo_tower:",
          "value": "🗼"
      },
      {
          "name": ":statue_of_liberty:",
          "value": "🗽"
      },
      {
          "name": ":japan:",
          "value": "🗾"
      },
      {
          "name": ":rocket:",
          "value": "🚀"
      },
      {
          "name": ":helicopter:",
          "value": "🚁"
      },
      {
          "name": ":steam_locomotive:",
          "value": "🚂"
      },
      {
          "name": ":railway_car:",
          "value": "🚃"
      },
      {
          "name": ":bullettrain_side:",
          "value": "🚄"
      },
      {
          "name": ":bullettrain_front:",
          "value": "🚅"
      },
      {
          "name": ":train2:",
          "value": "🚆"
      },
      {
          "name": ":metro:",
          "value": "🚇"
      },
      {
          "name": ":light_rail:",
          "value": "🚈"
      },
      {
          "name": ":station:",
          "value": "🚉"
      },
      {
          "name": ":tram:",
          "value": "🚊"
      },
      {
          "name": ":train:",
          "value": "🚋"
      },
      {
          "name": ":bus:",
          "value": "🚌"
      },
      {
          "name": ":oncoming_bus:",
          "value": "🚍"
      },
      {
          "name": ":trolleybus:",
          "value": "🚎"
      },
      {
          "name": ":busstop:",
          "value": "🚏"
      },
      {
          "name": ":minibus:",
          "value": "🚐"
      },
      {
          "name": ":ambulance:",
          "value": "🚑"
      },
      {
          "name": ":fire_engine:",
          "value": "🚒"
      },
      {
          "name": ":police_car:",
          "value": "🚓"
      },
      {
          "name": ":oncoming_police_car:",
          "value": "🚔"
      },
      {
          "name": ":taxi:",
          "value": "🚕"
      },
      {
          "name": ":oncoming_taxi:",
          "value": "🚖"
      },
      {
          "name": ":car:",
          "value": "🚗"
      },
      {
          "name": ":oncoming_automobile:",
          "value": "🚘"
      },
      {
          "name": ":blue_car:",
          "value": "🚙"
      },
      {
          "name": ":truck:",
          "value": "🚚"
      },
      {
          "name": ":articulated_lorry:",
          "value": "🚛"
      },
      {
          "name": ":tractor:",
          "value": "🚜"
      },
      {
          "name": ":monorail:",
          "value": "🚝"
      },
      {
          "name": ":mountain_railway:",
          "value": "🚞"
      },
      {
          "name": ":suspension_railway:",
          "value": "🚟"
      },
      {
          "name": ":mountain_cableway:",
          "value": "🚠"
      },
      {
          "name": ":aerial_tramway:",
          "value": "🚡"
      },
      {
          "name": ":ship:",
          "value": "🚢"
      },
      {
          "name": ":speedboat:",
          "value": "🚤"
      },
      {
          "name": ":traffic_light:",
          "value": "🚥"
      },
      {
          "name": ":vertical_traffic_light:",
          "value": "🚦"
      },
      {
          "name": ":construction:",
          "value": "🚧"
      },
      {
          "name": ":rotating_light:",
          "value": "🚨"
      },
      {
          "name": ":bike:",
          "value": "🚲"
      },
      {
          "name": ":motorway:",
          "value": "🛣"
      },
      {
          "name": ":railway_track:",
          "value": "🛤"
      },
      {
          "name": ":motor_boat:",
          "value": "🛥"
      },
      {
          "name": ":small_airplane:",
          "value": "🛩"
      },
      {
          "name": ":airplane_departure:",
          "value": "🛫"
      },
      {
          "name": ":airplane_arriving:",
          "value": "🛬"
      },
      {
          "name": ":satellite:",
          "value": "🛰"
      },
      {
          "name": ":passenger_ship:",
          "value": "🛳"
      }
  ],
  "Objects": [
      {
          "name": ":watch:",
          "value": "⌚"
      },
      {
          "name": ":hourglass:",
          "value": "⌛"
      },
      {
          "name": ":keyboard:",
          "value": "⌨"
      },
      {
          "name": ":alarm_clock:",
          "value": "⏰"
      },
      {
          "name": ":stopwatch:",
          "value": "⏱"
      },
      {
          "name": ":timer_clock:",
          "value": "⏲"
      },
      {
          "name": ":hourglass_flowing_sand:",
          "value": "⏳"
      },
      {
          "name": ":phone:",
          "value": "☎"
      },
      {
          "name": ":hammer_and_pick:",
          "value": "⚒"
      },
      {
          "name": ":crossed_swords:",
          "value": "⚔"
      },
      {
          "name": ":scales:",
          "value": "⚖"
      },
      {
          "name": ":alembic:",
          "value": "⚗"
      },
      {
          "name": ":gear:",
          "value": "⚙"
      },
      {
          "name": ":coffin:",
          "value": "⚰"
      },
      {
          "name": ":funeral_urn:",
          "value": "⚱"
      },
      {
          "name": ":pick:",
          "value": "⛏"
      },
      {
          "name": ":chains:",
          "value": "⛓"
      },
      {
          "name": ":scissors:",
          "value": "✂"
      },
      {
          "name": ":email:",
          "value": "✉"
      },
      {
          "name": ":pencil2:",
          "value": "✏"
      },
      {
          "name": ":black_nib:",
          "value": "✒"
      },
      {
          "name": ":ribbon:",
          "value": "🎀"
      },
      {
          "name": ":gift:",
          "value": "🎁"
      },
      {
          "name": ":balloon:",
          "value": "🎈"
      },
      {
          "name": ":tada:",
          "value": "🎉"
      },
      {
          "name": ":confetti_ball:",
          "value": "🎊"
      },
      {
          "name": ":tanabata_tree:",
          "value": "🎋"
      },
      {
          "name": ":bamboo:",
          "value": "🎍"
      },
      {
          "name": ":dolls:",
          "value": "🎎"
      },
      {
          "name": ":flags:",
          "value": "🎏"
      },
      {
          "name": ":wind_chime:",
          "value": "🎐"
      },
      {
          "name": ":rice_scene:",
          "value": "🎑"
      },
      {
          "name": ":reminder_ribbon:",
          "value": "🎗"
      },
      {
          "name": ":studio_microphone:",
          "value": "🎙"
      },
      {
          "name": ":level_slider:",
          "value": "🎚"
      },
      {
          "name": ":control_knobs:",
          "value": "🎛"
      },
      {
          "name": ":film_frames:",
          "value": "🎞"
      },
      {
          "name": ":admission_tickets:",
          "value": "🎟"
      },
      {
          "name": ":microphone:",
          "value": "🎤"
      },
      {
          "name": ":movie_camera:",
          "value": "🎥"
      },
      {
          "name": ":headphones:",
          "value": "🎧"
      },
      {
          "name": ":ticket:",
          "value": "🎫"
      },
      {
          "name": ":clapper:",
          "value": "🎬"
      },
      {
          "name": ":musical_note:",
          "value": "🎵"
      },
      {
          "name": ":notes:",
          "value": "🎶"
      },
      {
          "name": ":saxophone:",
          "value": "🎷"
      },
      {
          "name": ":guitar:",
          "value": "🎸"
      },
      {
          "name": ":musical_keyboard:",
          "value": "🎹"
      },
      {
          "name": ":trumpet:",
          "value": "🎺"
      },
      {
          "name": ":violin:",
          "value": "🎻"
      },
      {
          "name": ":musical_score:",
          "value": "🎼"
      },
      {
          "name": ":izakaya_lantern:",
          "value": "🏮"
      },
      {
          "name": ":label:",
          "value": "🏷"
      },
      {
          "name": ":bow_and_arrow:",
          "value": "🏹"
      },
      {
          "name": ":syringe:",
          "value": "💉"
      },
      {
          "name": ":pill:",
          "value": "💊"
      },
      {
          "name": ":bulb:",
          "value": "💡"
      },
      {
          "name": ":moneybag:",
          "value": "💰"
      },
      {
          "name": ":credit_card:",
          "value": "💳"
      },
      {
          "name": ":yen:",
          "value": "💴"
      },
      {
          "name": ":dollar:",
          "value": "💵"
      },
      {
          "name": ":euro:",
          "value": "💶"
      },
      {
          "name": ":pound:",
          "value": "💷"
      },
      {
          "name": ":money_with_wings:",
          "value": "💸"
      },
      {
          "name": ":computer:",
          "value": "💻"
      },
      {
          "name": ":briefcase:",
          "value": "💼"
      },
      {
          "name": ":minidisc:",
          "value": "💽"
      },
      {
          "name": ":floppy_disk:",
          "value": "💾"
      },
      {
          "name": ":cd:",
          "value": "💿"
      },
      {
          "name": ":dvd:",
          "value": "📀"
      },
      {
          "name": ":file_folder:",
          "value": "📁"
      },
      {
          "name": ":open_file_folder:",
          "value": "📂"
      },
      {
          "name": ":page_with_curl:",
          "value": "📃"
      },
      {
          "name": ":page_facing_up:",
          "value": "📄"
      },
      {
          "name": ":date:",
          "value": "📅"
      },
      {
          "name": ":calendar:",
          "value": "📆"
      },
      {
          "name": ":card_index:",
          "value": "📇"
      },
      {
          "name": ":chart_with_upwards_trend:",
          "value": "📈"
      },
      {
          "name": ":chart_with_downwards_trend:",
          "value": "📉"
      },
      {
          "name": ":bar_chart:",
          "value": "📊"
      },
      {
          "name": ":clipboard:",
          "value": "📋"
      },
      {
          "name": ":pushpin:",
          "value": "📌"
      },
      {
          "name": ":round_pushpin:",
          "value": "📍"
      },
      {
          "name": ":paperclip:",
          "value": "📎"
      },
      {
          "name": ":straight_ruler:",
          "value": "📏"
      },
      {
          "name": ":triangular_ruler:",
          "value": "📐"
      },
      {
          "name": ":bookmark_tabs:",
          "value": "📑"
      },
      {
          "name": ":ledger:",
          "value": "📒"
      },
      {
          "name": ":notebook:",
          "value": "📓"
      },
      {
          "name": ":notebook_with_decorative_cover:",
          "value": "📔"
      },
      {
          "name": ":closed_book:",
          "value": "📕"
      },
      {
          "name": ":book:",
          "value": "📖"
      },
      {
          "name": ":green_book:",
          "value": "📗"
      },
      {
          "name": ":blue_book:",
          "value": "📘"
      },
      {
          "name": ":orange_book:",
          "value": "📙"
      },
      {
          "name": ":books:",
          "value": "📚"
      },
      {
          "name": ":scroll:",
          "value": "📜"
      },
      {
          "name": ":memo:",
          "value": "📝"
      },
      {
          "name": ":telephone_receiver:",
          "value": "📞"
      },
      {
          "name": ":pager:",
          "value": "📟"
      },
      {
          "name": ":fax:",
          "value": "📠"
      },
      {
          "name": ":satellite_antenna:",
          "value": "📡"
      },
      {
          "name": ":outbox_tray:",
          "value": "📤"
      },
      {
          "name": ":inbox_tray:",
          "value": "📥"
      },
      {
          "name": ":package:",
          "value": "📦"
      },
      {
          "name": ":e-mail:",
          "value": "📧"
      },
      {
          "name": ":incoming_envelope:",
          "value": "📨"
      },
      {
          "name": ":envelope_with_arrow:",
          "value": "📩"
      },
      {
          "name": ":mailbox_closed:",
          "value": "📪"
      },
      {
          "name": ":mailbox:",
          "value": "📫"
      },
      {
          "name": ":mailbox_with_mail:",
          "value": "📬"
      },
      {
          "name": ":mailbox_with_no_mail:",
          "value": "📭"
      },
      {
          "name": ":postbox:",
          "value": "📮"
      },
      {
          "name": ":newspaper:",
          "value": "📰"
      },
      {
          "name": ":iphone:",
          "value": "📱"
      },
      {
          "name": ":calling:",
          "value": "📲"
      },
      {
          "name": ":camera:",
          "value": "📷"
      },
      {
          "name": ":camera_with_flash:",
          "value": "📸"
      },
      {
          "name": ":video_camera:",
          "value": "📹"
      },
      {
          "name": ":tv:",
          "value": "📺"
      },
      {
          "name": ":radio:",
          "value": "📻"
      },
      {
          "name": ":vhs:",
          "value": "📼"
      },
      {
          "name": ":film_projector:",
          "value": "📽"
      },
      {
          "name": ":battery:",
          "value": "🔋"
      },
      {
          "name": ":electric_plug:",
          "value": "🔌"
      },
      {
          "name": ":mag:",
          "value": "🔍"
      },
      {
          "name": ":mag_right:",
          "value": "🔎"
      },
      {
          "name": ":lock_with_ink_pen:",
          "value": "🔏"
      },
      {
          "name": ":closed_lock_with_key:",
          "value": "🔐"
      },
      {
          "name": ":key:",
          "value": "🔑"
      },
      {
          "name": ":lock:",
          "value": "🔒"
      },
      {
          "name": ":unlock:",
          "value": "🔓"
      },
      {
          "name": ":bookmark:",
          "value": "🔖"
      },
      {
          "name": ":link:",
          "value": "🔗"
      },
      {
          "name": ":flashlight:",
          "value": "🔦"
      },
      {
          "name": ":wrench:",
          "value": "🔧"
      },
      {
          "name": ":hammer:",
          "value": "🔨"
      },
      {
          "name": ":nut_and_bolt:",
          "value": "🔩"
      },
      {
          "name": ":gun:",
          "value": "🔫"
      },
      {
          "name": ":microscope:",
          "value": "🔬"
      },
      {
          "name": ":telescope:",
          "value": "🔭"
      },
      {
          "name": ":crystal_ball:",
          "value": "🔮"
      },
      {
          "name": ":candle:",
          "value": "🕯"
      },
      {
          "name": ":mantelpiece_clock:",
          "value": "🕰"
      },
      {
          "name": ":linked_paperclips:",
          "value": "🖇"
      },
      {
          "name": ":lower_left_ballpoint_pen:",
          "value": "🖊"
      },
      {
          "name": ":lower_left_fountain_pen:",
          "value": "🖋"
      },
      {
          "name": ":lower_left_paintbrush:",
          "value": "🖌"
      },
      {
          "name": ":lower_left_crayon:",
          "value": "🖍"
      },
      {
          "name": ":desktop_computer:",
          "value": "🖥"
      },
      {
          "name": ":printer:",
          "value": "🖨"
      },
      {
          "name": ":three_button_mouse:",
          "value": "🖱"
      },
      {
          "name": ":trackball:",
          "value": "🖲"
      },
      {
          "name": ":card_index_dividers:",
          "value": "🗂"
      },
      {
          "name": ":card_file_box:",
          "value": "🗃"
      },
      {
          "name": ":file_cabinet:",
          "value": "🗄"
      },
      {
          "name": ":wastebasket:",
          "value": "🗑"
      },
      {
          "name": ":spiral_note_pad:",
          "value": "🗒"
      },
      {
          "name": ":spiral_calendar_pad:",
          "value": "🗓"
      },
      {
          "name": ":compression:",
          "value": "🗜"
      },
      {
          "name": ":old_key:",
          "value": "🗝"
      },
      {
          "name": ":rolled_up_newspaper:",
          "value": "🗞"
      },
      {
          "name": ":dagger_knife:",
          "value": "🗡"
      },
      {
          "name": ":ballot_box_with_ballot:",
          "value": "🗳"
      },
      {
          "name": ":moyai:",
          "value": "🗿"
      },
      {
          "name": ":door:",
          "value": "🚪"
      },
      {
          "name": ":smoking:",
          "value": "🚬"
      },
      {
          "name": ":toilet:",
          "value": "🚽"
      },
      {
          "name": ":shower:",
          "value": "🚿"
      },
      {
          "name": ":bath:",
          "value": "🛀"
      },
      {
          "name": ":bathtub:",
          "value": "🛁"
      },
      {
          "name": ":couch_and_lamp:",
          "value": "🛋"
      },
      {
          "name": ":sleeping_accommodation:",
          "value": "🛌"
      },
      {
          "name": ":bellhop_bell:",
          "value": "🛎"
      },
      {
          "name": ":bed:",
          "value": "🛏"
      },
      {
          "name": ":hammer_and_wrench:",
          "value": "🛠"
      },
      {
          "name": ":shield:",
          "value": "🛡"
      },
      {
          "name": ":oil_drum:",
          "value": "🛢"
      }
  ],
  "Symbols": [
      {
          "name": ":copyright:",
          "value": "©"
      },
      {
          "name": ":registered:",
          "value": "®"
      },
      {
          "name": ":bangbang:",
          "value": "‼"
      },
      {
          "name": ":interrobang:",
          "value": "⁉"
      },
      {
          "name": ":tm:",
          "value": "™"
      },
      {
          "name": ":information_source:",
          "value": "ℹ"
      },
      {
          "name": ":left_right_arrow:",
          "value": "↔"
      },
      {
          "name": ":arrow_up_down:",
          "value": "↕"
      },
      {
          "name": ":arrow_upper_left:",
          "value": "↖"
      },
      {
          "name": ":arrow_upper_right:",
          "value": "↗"
      },
      {
          "name": ":arrow_lower_right:",
          "value": "↘"
      },
      {
          "name": ":arrow_lower_left:",
          "value": "↙"
      },
      {
          "name": ":leftwards_arrow_with_hook:",
          "value": "↩"
      },
      {
          "name": ":arrow_right_hook:",
          "value": "↪"
      },
      {
          "name": ":eject:",
          "value": "⏏"
      },
      {
          "name": ":fast_forward:",
          "value": "⏩"
      },
      {
          "name": ":rewind:",
          "value": "⏪"
      },
      {
          "name": ":arrow_double_up:",
          "value": "⏫"
      },
      {
          "name": ":arrow_double_down:",
          "value": "⏬"
      },
      {
          "name": ":black_right_pointing_double_triangle_with_vertical_bar:",
          "value": "⏭"
      },
      {
          "name": ":black_left_pointing_double_triangle_with_vertical_bar:",
          "value": "⏮"
      },
      {
          "name": ":black_right_pointing_triangle_with_double_vertical_bar:",
          "value": "⏯"
      },
      {
          "name": ":double_vertical_bar:",
          "value": "⏸"
      },
      {
          "name": ":black_square_for_stop:",
          "value": "⏹"
      },
      {
          "name": ":black_circle_for_record:",
          "value": "⏺"
      },
      {
          "name": ":m:",
          "value": "Ⓜ"
      },
      {
          "name": ":black_small_square:",
          "value": "▪"
      },
      {
          "name": ":white_small_square:",
          "value": "▫"
      },
      {
          "name": ":arrow_forward:",
          "value": "▶"
      },
      {
          "name": ":arrow_backward:",
          "value": "◀"
      },
      {
          "name": ":white_medium_square:",
          "value": "◻"
      },
      {
          "name": ":black_medium_square:",
          "value": "◼"
      },
      {
          "name": ":white_medium_small_square:",
          "value": "◽"
      },
      {
          "name": ":black_medium_small_square:",
          "value": "◾"
      },
      {
          "name": ":ballot_box_with_check:",
          "value": "☑"
      },
      {
          "name": ":radioactive_sign:",
          "value": "☢"
      },
      {
          "name": ":biohazard_sign:",
          "value": "☣"
      },
      {
          "name": ":orthodox_cross:",
          "value": "☦"
      },
      {
          "name": ":star_and_crescent:",
          "value": "☪"
      },
      {
          "name": ":peace_symbol:",
          "value": "☮"
      },
      {
          "name": ":yin_yang:",
          "value": "☯"
      },
      {
          "name": ":wheel_of_dharma:",
          "value": "☸"
      },
      {
          "name": ":aries:",
          "value": "♈"
      },
      {
          "name": ":taurus:",
          "value": "♉"
      },
      {
          "name": ":gemini:",
          "value": "♊"
      },
      {
          "name": ":cancer:",
          "value": "♋"
      },
      {
          "name": ":leo:",
          "value": "♌"
      },
      {
          "name": ":virgo:",
          "value": "♍"
      },
      {
          "name": ":libra:",
          "value": "♎"
      },
      {
          "name": ":scorpius:",
          "value": "♏"
      },
      {
          "name": ":sagittarius:",
          "value": "♐"
      },
      {
          "name": ":capricorn:",
          "value": "♑"
      },
      {
          "name": ":aquarius:",
          "value": "♒"
      },
      {
          "name": ":pisces:",
          "value": "♓"
      },
      {
          "name": ":recycle:",
          "value": "♻"
      },
      {
          "name": ":wheelchair:",
          "value": "♿"
      },
      {
          "name": ":atom_symbol:",
          "value": "⚛"
      },
      {
          "name": ":fleur_de_lis:",
          "value": "⚜"
      },
      {
          "name": ":warning:",
          "value": "⚠"
      },
      {
          "name": ":white_circle:",
          "value": "⚪"
      },
      {
          "name": ":black_circle:",
          "value": "⚫"
      },
      {
          "name": ":ophiuchus:",
          "value": "⛎"
      },
      {
          "name": ":no_entry:",
          "value": "⛔"
      },
      {
          "name": ":white_check_mark:",
          "value": "✅"
      },
      {
          "name": ":heavy_check_mark:",
          "value": "✔"
      },
      {
          "name": ":heavy_multiplication_x:",
          "value": "✖"
      },
      {
          "name": ":latin_cross:",
          "value": "✝"
      },
      {
          "name": ":star_of_david:",
          "value": "✡"
      },
      {
          "name": ":eight_spoked_asterisk:",
          "value": "✳"
      },
      {
          "name": ":eight_pointed_black_star:",
          "value": "✴"
      },
      {
          "name": ":sparkle:",
          "value": "❇"
      },
      {
          "name": ":x:",
          "value": "❌"
      },
      {
          "name": ":negative_squared_cross_mark:",
          "value": "❎"
      },
      {
          "name": ":question:",
          "value": "❓"
      },
      {
          "name": ":grey_question:",
          "value": "❔"
      },
      {
          "name": ":grey_exclamation:",
          "value": "❕"
      },
      {
          "name": ":exclamation:",
          "value": "❗"
      },
      {
          "name": ":heavy_heart_exclamation_mark_ornament:",
          "value": "❣"
      },
      {
          "name": ":heart:",
          "value": "❤"
      },
      {
          "name": ":heavy_plus_sign:",
          "value": "➕"
      },
      {
          "name": ":heavy_minus_sign:",
          "value": "➖"
      },
      {
          "name": ":heavy_division_sign:",
          "value": "➗"
      },
      {
          "name": ":arrow_right:",
          "value": "➡"
      },
      {
          "name": ":curly_loop:",
          "value": "➰"
      },
      {
          "name": ":loop:",
          "value": "➿"
      },
      {
          "name": ":arrow_heading_up:",
          "value": "⤴"
      },
      {
          "name": ":arrow_heading_down:",
          "value": "⤵"
      },
      {
          "name": ":arrow_left:",
          "value": "⬅"
      },
      {
          "name": ":arrow_up:",
          "value": "⬆"
      },
      {
          "name": ":arrow_down:",
          "value": "⬇"
      },
      {
          "name": ":black_large_square:",
          "value": "⬛"
      },
      {
          "name": ":white_large_square:",
          "value": "⬜"
      },
      {
          "name": ":o:",
          "value": "⭕"
      },
      {
          "name": ":wavy_dash:",
          "value": "〰"
      },
      {
          "name": ":part_alternation_mark:",
          "value": "〽"
      },
      {
          "name": ":congratulations:",
          "value": "㊗"
      },
      {
          "name": ":secret:",
          "value": "㊙"
      },
      {
          "name": ":a:",
          "value": "🅰"
      },
      {
          "name": ":b:",
          "value": "🅱"
      },
      {
          "name": ":o2:",
          "value": "🅾"
      },
      {
          "name": ":parking:",
          "value": "🅿"
      },
      {
          "name": ":ab:",
          "value": "🆎"
      },
      {
          "name": ":cl:",
          "value": "🆑"
      },
      {
          "name": ":cool:",
          "value": "🆒"
      },
      {
          "name": ":free:",
          "value": "🆓"
      },
      {
          "name": ":id:",
          "value": "🆔"
      },
      {
          "name": ":new:",
          "value": "🆕"
      },
      {
          "name": ":ng:",
          "value": "🆖"
      },
      {
          "name": ":ok:",
          "value": "🆗"
      },
      {
          "name": ":sos:",
          "value": "🆘"
      },
      {
          "name": ":up:",
          "value": "🆙"
      },
      {
          "name": ":vs:",
          "value": "🆚"
      },
      {
          "name": ":koko:",
          "value": "🈁"
      },
      {
          "name": ":sa:",
          "value": "🈂"
      },
      {
          "name": ":u7121:",
          "value": "🈚"
      },
      {
          "name": ":u6307:",
          "value": "🈯"
      },
      {
          "name": ":u7981:",
          "value": "🈲"
      },
      {
          "name": ":u7a7a:",
          "value": "🈳"
      },
      {
          "name": ":u5408:",
          "value": "🈴"
      },
      {
          "name": ":u6e80:",
          "value": "🈵"
      },
      {
          "name": ":u6709:",
          "value": "🈶"
      },
      {
          "name": ":u6708:",
          "value": "🈷"
      },
      {
          "name": ":u7533:",
          "value": "🈸"
      },
      {
          "name": ":u5272:",
          "value": "🈹"
      },
      {
          "name": ":u55b6:",
          "value": "🈺"
      },
      {
          "name": ":ideograph_advantage:",
          "value": "🉐"
      },
      {
          "name": ":accept:",
          "value": "🉑"
      },
      {
          "name": ":crossed_flags:",
          "value": "🎌"
      },
      {
          "name": ":cinema:",
          "value": "🎦"
      },
      {
          "name": ":checkered_flag:",
          "value": "🏁"
      },
      {
          "name": ":atm:",
          "value": "🏧"
      },
      {
          "name": ":waving_white_flag:",
          "value": "🏳"
      },
      {
          "name": ":waving_black_flag:",
          "value": "🏴"
      },
      {
          "name": ":heartbeat:",
          "value": "💓"
      },
      {
          "name": ":broken_heart:",
          "value": "💔"
      },
      {
          "name": ":two_hearts:",
          "value": "💕"
      },
      {
          "name": ":sparkling_heart:",
          "value": "💖"
      },
      {
          "name": ":heartpulse:",
          "value": "💗"
      },
      {
          "name": ":cupid:",
          "value": "💘"
      },
      {
          "name": ":blue_heart:",
          "value": "💙"
      },
      {
          "name": ":green_heart:",
          "value": "💚"
      },
      {
          "name": ":yellow_heart:",
          "value": "💛"
      },
      {
          "name": ":purple_heart:",
          "value": "💜"
      },
      {
          "name": ":gift_heart:",
          "value": "💝"
      },
      {
          "name": ":revolving_hearts:",
          "value": "💞"
      },
      {
          "name": ":heart_decoration:",
          "value": "💟"
      },
      {
          "name": ":diamond_shape_with_a_dot_inside:",
          "value": "💠"
      },
      {
          "name": ":speech_balloon:",
          "value": "💬"
      },
      {
          "name": ":thought_balloon:",
          "value": "💭"
      },
      {
          "name": ":100:",
          "value": "💯"
      },
      {
          "name": ":name_badge:",
          "value": "📛"
      },
      {
          "name": ":loudspeaker:",
          "value": "📢"
      },
      {
          "name": ":mega:",
          "value": "📣"
      },
      {
          "name": ":postal_horn:",
          "value": "📯"
      },
      {
          "name": ":vibration_mode:",
          "value": "📳"
      },
      {
          "name": ":mobile_phone_off:",
          "value": "📴"
      },
      {
          "name": ":no_mobile_phones:",
          "value": "📵"
      },
      {
          "name": ":signal_strength:",
          "value": "📶"
      },
      {
          "name": ":twisted_rightwards_arrows:",
          "value": "🔀"
      },
      {
          "name": ":repeat:",
          "value": "🔁"
      },
      {
          "name": ":repeat_one:",
          "value": "🔂"
      },
      {
          "name": ":arrows_clockwise:",
          "value": "🔃"
      },
      {
          "name": ":arrows_counterclockwise:",
          "value": "🔄"
      },
      {
          "name": ":low_brightness:",
          "value": "🔅"
      },
      {
          "name": ":high_brightness:",
          "value": "🔆"
      },
      {
          "name": ":mute:",
          "value": "🔇"
      },
      {
          "name": ":speaker:",
          "value": "🔈"
      },
      {
          "name": ":sound:",
          "value": "🔉"
      },
      {
          "name": ":loud_sound:",
          "value": "🔊"
      },
      {
          "name": ":bell:",
          "value": "🔔"
      },
      {
          "name": ":no_bell:",
          "value": "🔕"
      },
      {
          "name": ":radio_button:",
          "value": "🔘"
      },
      {
          "name": ":back:",
          "value": "🔙"
      },
      {
          "name": ":end:",
          "value": "🔚"
      },
      {
          "name": ":on:",
          "value": "🔛"
      },
      {
          "name": ":soon:",
          "value": "🔜"
      },
      {
          "name": ":top:",
          "value": "🔝"
      },
      {
          "name": ":underage:",
          "value": "🔞"
      },
      {
          "name": ":keycap_ten:",
          "value": "🔟"
      },
      {
          "name": ":capital_abcd:",
          "value": "🔠"
      },
      {
          "name": ":abcd:",
          "value": "🔡"
      },
      {
          "name": ":1234:",
          "value": "🔢"
      },
      {
          "name": ":symbols:",
          "value": "🔣"
      },
      {
          "name": ":abc:",
          "value": "🔤"
      },
      {
          "name": ":six_pointed_star:",
          "value": "🔯"
      },
      {
          "name": ":beginner:",
          "value": "🔰"
      },
      {
          "name": ":trident:",
          "value": "🔱"
      },
      {
          "name": ":black_square_button:",
          "value": "🔲"
      },
      {
          "name": ":white_square_button:",
          "value": "🔳"
      },
      {
          "name": ":red_circle:",
          "value": "🔴"
      },
      {
          "name": ":large_blue_circle:",
          "value": "🔵"
      },
      {
          "name": ":large_orange_diamond:",
          "value": "🔶"
      },
      {
          "name": ":large_blue_diamond:",
          "value": "🔷"
      },
      {
          "name": ":small_orange_diamond:",
          "value": "🔸"
      },
      {
          "name": ":small_blue_diamond:",
          "value": "🔹"
      },
      {
          "name": ":small_red_triangle:",
          "value": "🔺"
      },
      {
          "name": ":small_red_triangle_down:",
          "value": "🔻"
      },
      {
          "name": ":arrow_up_small:",
          "value": "🔼"
      },
      {
          "name": ":arrow_down_small:",
          "value": "🔽"
      },
      {
          "name": ":om_symbol:",
          "value": "🕉"
      },
      {
          "name": ":menorah_with_nine_branches:",
          "value": "🕎"
      },
      {
          "name": ":clock1:",
          "value": "🕐"
      },
      {
          "name": ":clock2:",
          "value": "🕑"
      },
      {
          "name": ":clock3:",
          "value": "🕒"
      },
      {
          "name": ":clock4:",
          "value": "🕓"
      },
      {
          "name": ":clock5:",
          "value": "🕔"
      },
      {
          "name": ":clock6:",
          "value": "🕕"
      },
      {
          "name": ":clock7:",
          "value": "🕖"
      },
      {
          "name": ":clock8:",
          "value": "🕗"
      },
      {
          "name": ":clock9:",
          "value": "🕘"
      },
      {
          "name": ":clock10:",
          "value": "🕙"
      },
      {
          "name": ":clock11:",
          "value": "🕚"
      },
      {
          "name": ":clock12:",
          "value": "🕛"
      },
      {
          "name": ":clock130:",
          "value": "🕜"
      },
      {
          "name": ":clock230:",
          "value": "🕝"
      },
      {
          "name": ":clock330:",
          "value": "🕞"
      },
      {
          "name": ":clock430:",
          "value": "🕟"
      },
      {
          "name": ":clock530:",
          "value": "🕠"
      },
      {
          "name": ":clock630:",
          "value": "🕡"
      },
      {
          "name": ":clock730:",
          "value": "🕢"
      },
      {
          "name": ":clock830:",
          "value": "🕣"
      },
      {
          "name": ":clock930:",
          "value": "🕤"
      },
      {
          "name": ":clock1030:",
          "value": "🕥"
      },
      {
          "name": ":clock1130:",
          "value": "🕦"
      },
      {
          "name": ":clock1230:",
          "value": "🕧"
      },
      {
          "name": ":left_speech_bubble:",
          "value": "🗨"
      },
      {
          "name": ":right_anger_bubble:",
          "value": "🗯"
      },
      {
          "name": ":triangular_flag_on_post:",
          "value": "🚩"
      },
      {
          "name": ":no_entry_sign:",
          "value": "🚫"
      },
      {
          "name": ":no_smoking:",
          "value": "🚭"
      },
      {
          "name": ":put_litter_in_its_place:",
          "value": "🚮"
      },
      {
          "name": ":do_not_litter:",
          "value": "🚯"
      },
      {
          "name": ":potable_water:",
          "value": "🚰"
      },
      {
          "name": ":non-potable_water:",
          "value": "🚱"
      },
      {
          "name": ":no_bicycles:",
          "value": "🚳"
      },
      {
          "name": ":no_pedestrians:",
          "value": "🚷"
      },
      {
          "name": ":children_crossing:",
          "value": "🚸"
      },
      {
          "name": ":mens:",
          "value": "🚹"
      },
      {
          "name": ":womens:",
          "value": "🚺"
      },
      {
          "name": ":restroom:",
          "value": "🚻"
      },
      {
          "name": ":baby_symbol:",
          "value": "🚼"
      },
      {
          "name": ":wc:",
          "value": "🚾"
      },
      {
          "name": ":passport_control:",
          "value": "🛂"
      },
      {
          "name": ":customs:",
          "value": "🛃"
      },
      {
          "name": ":baggage_claim:",
          "value": "🛄"
      },
      {
          "name": ":left_luggage:",
          "value": "🛅"
      },
      {
          "name": ":place_of_worship:",
          "value": "🛐"
      }
  ],
  "Flags": [
      {
          "name": ":flag-ac:",
          "value": "🇦🇨"
      },
      {
          "name": ":flag-ad:",
          "value": "🇦🇩"
      },
      {
          "name": ":flag-ae:",
          "value": "🇦🇪"
      },
      {
          "name": ":flag-af:",
          "value": "🇦🇫"
      },
      {
          "name": ":flag-ag:",
          "value": "🇦🇬"
      },
      {
          "name": ":flag-ai:",
          "value": "🇦🇮"
      },
      {
          "name": ":flag-al:",
          "value": "🇦🇱"
      },
      {
          "name": ":flag-am:",
          "value": "🇦🇲"
      },
      {
          "name": ":flag-ao:",
          "value": "🇦🇴"
      },
      {
          "name": ":flag-aq:",
          "value": "🇦🇶"
      },
      {
          "name": ":flag-ar:",
          "value": "🇦🇷"
      },
      {
          "name": ":flag-as:",
          "value": "🇦🇸"
      },
      {
          "name": ":flag-at:",
          "value": "🇦🇹"
      },
      {
          "name": ":flag-au:",
          "value": "🇦🇺"
      },
      {
          "name": ":flag-aw:",
          "value": "🇦🇼"
      },
      {
          "name": ":flag-ax:",
          "value": "🇦🇽"
      },
      {
          "name": ":flag-az:",
          "value": "🇦🇿"
      },
      {
          "name": ":flag-ba:",
          "value": "🇧🇦"
      },
      {
          "name": ":flag-bb:",
          "value": "🇧🇧"
      },
      {
          "name": ":flag-bd:",
          "value": "🇧🇩"
      },
      {
          "name": ":flag-be:",
          "value": "🇧🇪"
      },
      {
          "name": ":flag-bf:",
          "value": "🇧🇫"
      },
      {
          "name": ":flag-bg:",
          "value": "🇧🇬"
      },
      {
          "name": ":flag-bh:",
          "value": "🇧🇭"
      },
      {
          "name": ":flag-bi:",
          "value": "🇧🇮"
      },
      {
          "name": ":flag-bj:",
          "value": "🇧🇯"
      },
      {
          "name": ":flag-bl:",
          "value": "🇧🇱"
      },
      {
          "name": ":flag-bm:",
          "value": "🇧🇲"
      },
      {
          "name": ":flag-bn:",
          "value": "🇧🇳"
      },
      {
          "name": ":flag-bo:",
          "value": "🇧🇴"
      },
      {
          "name": ":flag-bq:",
          "value": "🇧🇶"
      },
      {
          "name": ":flag-br:",
          "value": "🇧🇷"
      },
      {
          "name": ":flag-bs:",
          "value": "🇧🇸"
      },
      {
          "name": ":flag-bt:",
          "value": "🇧🇹"
      },
      {
          "name": ":flag-bv:",
          "value": "🇧🇻"
      },
      {
          "name": ":flag-bw:",
          "value": "🇧🇼"
      },
      {
          "name": ":flag-by:",
          "value": "🇧🇾"
      },
      {
          "name": ":flag-bz:",
          "value": "🇧🇿"
      },
      {
          "name": ":flag-ca:",
          "value": "🇨🇦"
      },
      {
          "name": ":flag-cc:",
          "value": "🇨🇨"
      },
      {
          "name": ":flag-cd:",
          "value": "🇨🇩"
      },
      {
          "name": ":flag-cf:",
          "value": "🇨🇫"
      },
      {
          "name": ":flag-cg:",
          "value": "🇨🇬"
      },
      {
          "name": ":flag-ch:",
          "value": "🇨🇭"
      },
      {
          "name": ":flag-ci:",
          "value": "🇨🇮"
      },
      {
          "name": ":flag-ck:",
          "value": "🇨🇰"
      },
      {
          "name": ":flag-cl:",
          "value": "🇨🇱"
      },
      {
          "name": ":flag-cm:",
          "value": "🇨🇲"
      },
      {
          "name": ":flag-cn:",
          "value": "🇨🇳"
      },
      {
          "name": ":flag-co:",
          "value": "🇨🇴"
      },
      {
          "name": ":flag-cp:",
          "value": "🇨🇵"
      },
      {
          "name": ":flag-cr:",
          "value": "🇨🇷"
      },
      {
          "name": ":flag-cu:",
          "value": "🇨🇺"
      },
      {
          "name": ":flag-cv:",
          "value": "🇨🇻"
      },
      {
          "name": ":flag-cw:",
          "value": "🇨🇼"
      },
      {
          "name": ":flag-cx:",
          "value": "🇨🇽"
      },
      {
          "name": ":flag-cy:",
          "value": "🇨🇾"
      },
      {
          "name": ":flag-cz:",
          "value": "🇨🇿"
      },
      {
          "name": ":flag-de:",
          "value": "🇩🇪"
      },
      {
          "name": ":flag-dg:",
          "value": "🇩🇬"
      },
      {
          "name": ":flag-dj:",
          "value": "🇩🇯"
      },
      {
          "name": ":flag-dk:",
          "value": "🇩🇰"
      },
      {
          "name": ":flag-dm:",
          "value": "🇩🇲"
      },
      {
          "name": ":flag-do:",
          "value": "🇩🇴"
      },
      {
          "name": ":flag-dz:",
          "value": "🇩🇿"
      },
      {
          "name": ":flag-ea:",
          "value": "🇪🇦"
      },
      {
          "name": ":flag-ec:",
          "value": "🇪🇨"
      },
      {
          "name": ":flag-ee:",
          "value": "🇪🇪"
      },
      {
          "name": ":flag-eg:",
          "value": "🇪🇬"
      },
      {
          "name": ":flag-eh:",
          "value": "🇪🇭"
      },
      {
          "name": ":flag-er:",
          "value": "🇪🇷"
      },
      {
          "name": ":flag-es:",
          "value": "🇪🇸"
      },
      {
          "name": ":flag-et:",
          "value": "🇪🇹"
      },
      {
          "name": ":flag-eu:",
          "value": "🇪🇺"
      },
      {
          "name": ":flag-fi:",
          "value": "🇫🇮"
      },
      {
          "name": ":flag-fj:",
          "value": "🇫🇯"
      },
      {
          "name": ":flag-fk:",
          "value": "🇫🇰"
      },
      {
          "name": ":flag-fm:",
          "value": "🇫🇲"
      },
      {
          "name": ":flag-fo:",
          "value": "🇫🇴"
      },
      {
          "name": ":flag-fr:",
          "value": "🇫🇷"
      },
      {
          "name": ":flag-ga:",
          "value": "🇬🇦"
      },
      {
          "name": ":flag-gb:",
          "value": "🇬🇧"
      },
      {
          "name": ":flag-gd:",
          "value": "🇬🇩"
      },
      {
          "name": ":flag-ge:",
          "value": "🇬🇪"
      },
      {
          "name": ":flag-gf:",
          "value": "🇬🇫"
      },
      {
          "name": ":flag-gg:",
          "value": "🇬🇬"
      },
      {
          "name": ":flag-gh:",
          "value": "🇬🇭"
      },
      {
          "name": ":flag-gi:",
          "value": "🇬🇮"
      },
      {
          "name": ":flag-gl:",
          "value": "🇬🇱"
      },
      {
          "name": ":flag-gm:",
          "value": "🇬🇲"
      },
      {
          "name": ":flag-gn:",
          "value": "🇬🇳"
      },
      {
          "name": ":flag-gp:",
          "value": "🇬🇵"
      },
      {
          "name": ":flag-gq:",
          "value": "🇬🇶"
      },
      {
          "name": ":flag-gr:",
          "value": "🇬🇷"
      },
      {
          "name": ":flag-gs:",
          "value": "🇬🇸"
      },
      {
          "name": ":flag-gt:",
          "value": "🇬🇹"
      },
      {
          "name": ":flag-gu:",
          "value": "🇬🇺"
      },
      {
          "name": ":flag-gw:",
          "value": "🇬🇼"
      },
      {
          "name": ":flag-gy:",
          "value": "🇬🇾"
      },
      {
          "name": ":flag-hk:",
          "value": "🇭🇰"
      },
      {
          "name": ":flag-hm:",
          "value": "🇭🇲"
      },
      {
          "name": ":flag-hn:",
          "value": "🇭🇳"
      },
      {
          "name": ":flag-hr:",
          "value": "🇭🇷"
      },
      {
          "name": ":flag-ht:",
          "value": "🇭🇹"
      },
      {
          "name": ":flag-hu:",
          "value": "🇭🇺"
      },
      {
          "name": ":flag-ic:",
          "value": "🇮🇨"
      },
      {
          "name": ":flag-id:",
          "value": "🇮🇩"
      },
      {
          "name": ":flag-ie:",
          "value": "🇮🇪"
      },
      {
          "name": ":flag-il:",
          "value": "🇮🇱"
      },
      {
          "name": ":flag-im:",
          "value": "🇮🇲"
      },
      {
          "name": ":flag-in:",
          "value": "🇮🇳"
      },
      {
          "name": ":flag-io:",
          "value": "🇮🇴"
      },
      {
          "name": ":flag-iq:",
          "value": "🇮🇶"
      },
      {
          "name": ":flag-ir:",
          "value": "🇮🇷"
      },
      {
          "name": ":flag-is:",
          "value": "🇮🇸"
      },
      {
          "name": ":flag-it:",
          "value": "🇮🇹"
      },
      {
          "name": ":flag-je:",
          "value": "🇯🇪"
      },
      {
          "name": ":flag-jm:",
          "value": "🇯🇲"
      },
      {
          "name": ":flag-jo:",
          "value": "🇯🇴"
      },
      {
          "name": ":flag-jp:",
          "value": "🇯🇵"
      },
      {
          "name": ":flag-ke:",
          "value": "🇰🇪"
      },
      {
          "name": ":flag-kg:",
          "value": "🇰🇬"
      },
      {
          "name": ":flag-kh:",
          "value": "🇰🇭"
      },
      {
          "name": ":flag-ki:",
          "value": "🇰🇮"
      },
      {
          "name": ":flag-km:",
          "value": "🇰🇲"
      },
      {
          "name": ":flag-kn:",
          "value": "🇰🇳"
      },
      {
          "name": ":flag-kp:",
          "value": "🇰🇵"
      },
      {
          "name": ":flag-kr:",
          "value": "🇰🇷"
      },
      {
          "name": ":flag-kw:",
          "value": "🇰🇼"
      },
      {
          "name": ":flag-ky:",
          "value": "🇰🇾"
      },
      {
          "name": ":flag-kz:",
          "value": "🇰🇿"
      },
      {
          "name": ":flag-la:",
          "value": "🇱🇦"
      },
      {
          "name": ":flag-lb:",
          "value": "🇱🇧"
      },
      {
          "name": ":flag-lc:",
          "value": "🇱🇨"
      },
      {
          "name": ":flag-li:",
          "value": "🇱🇮"
      },
      {
          "name": ":flag-lk:",
          "value": "🇱🇰"
      },
      {
          "name": ":flag-lr:",
          "value": "🇱🇷"
      },
      {
          "name": ":flag-ls:",
          "value": "🇱🇸"
      },
      {
          "name": ":flag-lt:",
          "value": "🇱🇹"
      },
      {
          "name": ":flag-lu:",
          "value": "🇱🇺"
      },
      {
          "name": ":flag-lv:",
          "value": "🇱🇻"
      },
      {
          "name": ":flag-ly:",
          "value": "🇱🇾"
      },
      {
          "name": ":flag-ma:",
          "value": "🇲🇦"
      },
      {
          "name": ":flag-mc:",
          "value": "🇲🇨"
      },
      {
          "name": ":flag-md:",
          "value": "🇲🇩"
      },
      {
          "name": ":flag-me:",
          "value": "🇲🇪"
      },
      {
          "name": ":flag-mf:",
          "value": "🇲🇫"
      },
      {
          "name": ":flag-mg:",
          "value": "🇲🇬"
      },
      {
          "name": ":flag-mh:",
          "value": "🇲🇭"
      },
      {
          "name": ":flag-mk:",
          "value": "🇲🇰"
      },
      {
          "name": ":flag-ml:",
          "value": "🇲🇱"
      },
      {
          "name": ":flag-mm:",
          "value": "🇲🇲"
      },
      {
          "name": ":flag-mn:",
          "value": "🇲🇳"
      },
      {
          "name": ":flag-mo:",
          "value": "🇲🇴"
      },
      {
          "name": ":flag-mp:",
          "value": "🇲🇵"
      },
      {
          "name": ":flag-mq:",
          "value": "🇲🇶"
      },
      {
          "name": ":flag-mr:",
          "value": "🇲🇷"
      },
      {
          "name": ":flag-ms:",
          "value": "🇲🇸"
      },
      {
          "name": ":flag-mt:",
          "value": "🇲🇹"
      },
      {
          "name": ":flag-mu:",
          "value": "🇲🇺"
      },
      {
          "name": ":flag-mv:",
          "value": "🇲🇻"
      },
      {
          "name": ":flag-mw:",
          "value": "🇲🇼"
      },
      {
          "name": ":flag-mx:",
          "value": "🇲🇽"
      },
      {
          "name": ":flag-my:",
          "value": "🇲🇾"
      },
      {
          "name": ":flag-mz:",
          "value": "🇲🇿"
      },
      {
          "name": ":flag-na:",
          "value": "🇳🇦"
      },
      {
          "name": ":flag-nc:",
          "value": "🇳🇨"
      },
      {
          "name": ":flag-ne:",
          "value": "🇳🇪"
      },
      {
          "name": ":flag-nf:",
          "value": "🇳🇫"
      },
      {
          "name": ":flag-ng:",
          "value": "🇳🇬"
      },
      {
          "name": ":flag-ni:",
          "value": "🇳🇮"
      },
      {
          "name": ":flag-nl:",
          "value": "🇳🇱"
      },
      {
          "name": ":flag-no:",
          "value": "🇳🇴"
      },
      {
          "name": ":flag-np:",
          "value": "🇳🇵"
      },
      {
          "name": ":flag-nr:",
          "value": "🇳🇷"
      },
      {
          "name": ":flag-nu:",
          "value": "🇳🇺"
      },
      {
          "name": ":flag-nz:",
          "value": "🇳🇿"
      },
      {
          "name": ":flag-om:",
          "value": "🇴🇲"
      },
      {
          "name": ":flag-pa:",
          "value": "🇵🇦"
      },
      {
          "name": ":flag-pe:",
          "value": "🇵🇪"
      },
      {
          "name": ":flag-pf:",
          "value": "🇵🇫"
      },
      {
          "name": ":flag-pg:",
          "value": "🇵🇬"
      },
      {
          "name": ":flag-ph:",
          "value": "🇵🇭"
      },
      {
          "name": ":flag-pk:",
          "value": "🇵🇰"
      },
      {
          "name": ":flag-pl:",
          "value": "🇵🇱"
      },
      {
          "name": ":flag-pm:",
          "value": "🇵🇲"
      },
      {
          "name": ":flag-pn:",
          "value": "🇵🇳"
      },
      {
          "name": ":flag-pr:",
          "value": "🇵🇷"
      },
      {
          "name": ":flag-ps:",
          "value": "🇵🇸"
      },
      {
          "name": ":flag-pt:",
          "value": "🇵🇹"
      },
      {
          "name": ":flag-pw:",
          "value": "🇵🇼"
      },
      {
          "name": ":flag-py:",
          "value": "🇵🇾"
      },
      {
          "name": ":flag-qa:",
          "value": "🇶🇦"
      },
      {
          "name": ":flag-re:",
          "value": "🇷🇪"
      },
      {
          "name": ":flag-ro:",
          "value": "🇷🇴"
      },
      {
          "name": ":flag-rs:",
          "value": "🇷🇸"
      },
      {
          "name": ":flag-ru:",
          "value": "🇷🇺"
      },
      {
          "name": ":flag-rw:",
          "value": "🇷🇼"
      },
      {
          "name": ":flag-sa:",
          "value": "🇸🇦"
      },
      {
          "name": ":flag-sb:",
          "value": "🇸🇧"
      },
      {
          "name": ":flag-sc:",
          "value": "🇸🇨"
      },
      {
          "name": ":flag-sd:",
          "value": "🇸🇩"
      },
      {
          "name": ":flag-se:",
          "value": "🇸🇪"
      },
      {
          "name": ":flag-sg:",
          "value": "🇸🇬"
      },
      {
          "name": ":flag-sh:",
          "value": "🇸🇭"
      },
      {
          "name": ":flag-si:",
          "value": "🇸🇮"
      },
      {
          "name": ":flag-sj:",
          "value": "🇸🇯"
      },
      {
          "name": ":flag-sk:",
          "value": "🇸🇰"
      },
      {
          "name": ":flag-sl:",
          "value": "🇸🇱"
      },
      {
          "name": ":flag-sm:",
          "value": "🇸🇲"
      },
      {
          "name": ":flag-sn:",
          "value": "🇸🇳"
      },
      {
          "name": ":flag-so:",
          "value": "🇸🇴"
      },
      {
          "name": ":flag-sr:",
          "value": "🇸🇷"
      },
      {
          "name": ":flag-ss:",
          "value": "🇸🇸"
      },
      {
          "name": ":flag-st:",
          "value": "🇸🇹"
      },
      {
          "name": ":flag-sv:",
          "value": "🇸🇻"
      },
      {
          "name": ":flag-sx:",
          "value": "🇸🇽"
      },
      {
          "name": ":flag-sy:",
          "value": "🇸🇾"
      },
      {
          "name": ":flag-sz:",
          "value": "🇸🇿"
      },
      {
          "name": ":flag-ta:",
          "value": "🇹🇦"
      },
      {
          "name": ":flag-tc:",
          "value": "🇹🇨"
      },
      {
          "name": ":flag-td:",
          "value": "🇹🇩"
      },
      {
          "name": ":flag-tf:",
          "value": "🇹🇫"
      },
      {
          "name": ":flag-tg:",
          "value": "🇹🇬"
      },
      {
          "name": ":flag-th:",
          "value": "🇹🇭"
      },
      {
          "name": ":flag-tj:",
          "value": "🇹🇯"
      },
      {
          "name": ":flag-tk:",
          "value": "🇹🇰"
      },
      {
          "name": ":flag-tl:",
          "value": "🇹🇱"
      },
      {
          "name": ":flag-tm:",
          "value": "🇹🇲"
      },
      {
          "name": ":flag-tn:",
          "value": "🇹🇳"
      },
      {
          "name": ":flag-to:",
          "value": "🇹🇴"
      },
      {
          "name": ":flag-tr:",
          "value": "🇹🇷"
      },
      {
          "name": ":flag-tt:",
          "value": "🇹🇹"
      },
      {
          "name": ":flag-tv:",
          "value": "🇹🇻"
      },
      {
          "name": ":flag-tw:",
          "value": "🇹🇼"
      },
      {
          "name": ":flag-tz:",
          "value": "🇹🇿"
      },
      {
          "name": ":flag-ua:",
          "value": "🇺🇦"
      },
      {
          "name": ":flag-ug:",
          "value": "🇺🇬"
      },
      {
          "name": ":flag-um:",
          "value": "🇺🇲"
      },
      {
          "name": ":flag-us:",
          "value": "🇺🇸"
      },
      {
          "name": ":flag-uy:",
          "value": "🇺🇾"
      },
      {
          "name": ":flag-uz:",
          "value": "🇺🇿"
      },
      {
          "name": ":flag-va:",
          "value": "🇻🇦"
      },
      {
          "name": ":flag-vc:",
          "value": "🇻🇨"
      },
      {
          "name": ":flag-ve:",
          "value": "🇻🇪"
      },
      {
          "name": ":flag-vg:",
          "value": "🇻🇬"
      },
      {
          "name": ":flag-vi:",
          "value": "🇻🇮"
      },
      {
          "name": ":flag-vn:",
          "value": "🇻🇳"
      },
      {
          "name": ":flag-vu:",
          "value": "🇻🇺"
      },
      {
          "name": ":flag-wf:",
          "value": "🇼🇫"
      },
      {
          "name": ":flag-ws:",
          "value": "🇼🇸"
      },
      {
          "name": ":flag-xk:",
          "value": "🇽🇰"
      },
      {
          "name": ":flag-ye:",
          "value": "🇾🇪"
      },
      {
          "name": ":flag-yt:",
          "value": "🇾🇹"
      },
      {
          "name": ":flag-za:",
          "value": "🇿🇦"
      },
      {
          "name": ":flag-zm:",
          "value": "🇿🇲"
      },
      {
          "name": ":flag-zw:",
          "value": "🇿🇼"
      }
  ]
};

  
export default HuEmoji;


// WEBPACK FOOTER //
// ./app/js/components/plugins/HuEmoji.js